export const fundingOptions = [
  { label: 'Employment income', value: 'employment_income' },
  { label: 'Personal savings', value: 'personal_savings' },
  { label: 'Personal inheritance', value: 'personal_inheritance' },
  { label: 'Business profits', value: 'business_profits' },
  { label: 'Investment gains or income', value: 'investment_gains' },
  { label: 'Institutional loans', value: 'institutional_loans' },
  { label: 'Loans from family or friends', value: 'loans_from_family_friends' },
  {
    label: 'Investors (including venture capital and business partners)',
    value: 'investors',
  },
];

export const reasonsForOpeningInSG = [
  { label: 'I live in Singapore', value: 'resident' },
  {
    label: 'I am expanding my existing business into Singapore',
    value: 'business_expansion',
  },
  { label: 'I am expanding into Asia more broadly', value: 'asia_expansion' },
  {
    label: 'Singapore is a great place to do business',
    value: 'business_environment',
  },
  {
    label:
      'A client, vendor, or partner have requested I expand into Singapore',
    value: 'partner_request',
  },
  { label: 'Other', value: 'Other' },
];

export const optionsSSIC = [
  {
    ssic_code: '1',
    title: 'Agriculture and Related Service Activities',
  },
  {
    ssic_code: '10',
    title: 'Manufacture of Food Products',
  },
  {
    ssic_code: '1010',
    title: 'Processing and Preserving of Meat',
  },
  {
    ssic_code: '10101',
    title: 'Slaughtering of Livestock and Poultry',
  },
  {
    ssic_code: '10102',
    title: 'Manufacture of Sausage',
  },
  {
    ssic_code: '10103',
    title:
      'Preparing, Canning and Preserving of Livestock and Livestock Products (including Lard and Other Edible Animal Fats)',
  },
  {
    ssic_code: '10104',
    title: 'Preparing, Canning and Preserving of Poultry and Poultry Products',
  },
  {
    ssic_code: '10109',
    title: 'Processing and Preserving of Meat and Meat Products n.e.c.',
  },
  {
    ssic_code: '10200',
    title: 'Processing and Preserving of Seafood',
  },
  {
    ssic_code: '1030',
    title: 'Processing and Preserving of Fruits and Vegetables',
  },
  {
    ssic_code: '10301',
    title: 'Manufacture of Jams (including Fruit Jelly)',
  },
  {
    ssic_code: '10302',
    title: 'Other Canning and Preserving of Fruits and Fruit Juices',
  },
  {
    ssic_code: '10303',
    title:
      'Other Canning and Preserving of Vegetables and Vegetable Juices (including Pickles)',
  },
  {
    ssic_code: '1040',
    title: 'Manufacture of Vegetable and Animal Oils and Fats',
  },
  {
    ssic_code: '10401',
    title: 'Manufacture of Edible Vegetable and Animal Oils and Fats',
  },
  {
    ssic_code: '10402',
    title: 'Manufacture of Inedible Vegetable and Animal Oils and Fats',
  },
  {
    ssic_code: '10409',
    title: 'Manufacture of Vegetable and Animal Oils and Fats n.e.c.',
  },
  {
    ssic_code: '1050',
    title: 'Manufacture of Dairy Products',
  },
  {
    ssic_code: '10501',
    title:
      'Manufacture of Condensed and Evaporated Milk (including Pasteurising and Bottling of Fluid Milk)',
  },
  {
    ssic_code: '10502',
    title: 'Manufacture of Milk Powder',
  },
  {
    ssic_code: '10503',
    title: 'Manufacture of Ice-Cream',
  },
  {
    ssic_code: '10509',
    title:
      'Manufacture of Dairy Products n.e.c. (e.g. Butter, Cheese, Ice-Cream Mixes and Powder, Yoghurt)',
  },
  {
    ssic_code: '106',
    title: 'Manufacture of Grain Mill Products, Starches and Starch Products',
  },
  {
    ssic_code: '1061',
    title: 'Manufacture of Grain Mill Products',
  },
  {
    ssic_code: '10611',
    title: 'Rice Milling',
  },
  {
    ssic_code: '10612',
    title: 'Wheat Milling',
  },
  {
    ssic_code: '10613',
    title: 'Provision of Milling Services',
  },
  {
    ssic_code: '10619',
    title: 'Manufacture of Grain Mill Products n.e.c.',
  },
  {
    ssic_code: '10620',
    title: 'Manufacture of Starches and Starch Products',
  },
  {
    ssic_code: '107',
    title: 'Manufacture of Other Food Products',
  },
  {
    ssic_code: '1071',
    title: 'Manufacture of Bakery Products',
  },
  {
    ssic_code: '10711',
    title: 'Manufacture of Biscuits (including Wafers and Cones)',
  },
  {
    ssic_code: '10712',
    title:
      'Manufacture of Bread, Cakes and Confectionery (excluding Frozen Bakery Products)',
  },
  {
    ssic_code: '10719',
    title: 'Manufacture of Bakery Products n.e.c.',
  },
  {
    ssic_code: '1072',
    title: 'Manufacture of Sugar',
  },
  {
    ssic_code: '10720',
    title: 'Manufacture of Sugar and Sugar Products',
  },
  {
    ssic_code: '1073',
    title: 'Manufacture of Cocoa, Chocolate and Non-Chocolate Confectionery',
  },
  {
    ssic_code: '10731',
    title: 'Manufacture of Cocoa and Chocolate Powder From Beans',
  },
  {
    ssic_code: '10732',
    title: 'Manufacture of Chocolate and Chocolate Products',
  },
  {
    ssic_code: '10733',
    title:
      'Manufacture of Non-Chocolate Confectionery (e.g. Sweets, Toffees, Crystallised Fruits, Chewing Gums)',
  },
  {
    ssic_code: '10740',
    title:
      'Manufacture of Macaroni, Noodles, Vermicelli and Other Related Products',
  },
  {
    ssic_code: '1075',
    title: 'Manufacture of Prepared Meals and Dishes',
  },
  {
    ssic_code: '10750',
    title: 'Manufacture of Cooked-Food Preparations (e.g. Frozen Dinners)',
  },
  {
    ssic_code: '1076',
    title: 'Manufacture of Coffee, Tea and Related Products',
  },
  {
    ssic_code: '10761',
    title: 'Manufacture of Instant Beverages',
  },
  {
    ssic_code: '10762',
    title: 'Processing of Coffee Seeds',
  },
  {
    ssic_code: '10763',
    title: 'Manufacture of Coffee Powder',
  },
  {
    ssic_code: '10764',
    title: 'Manufacture of Tea (including Processing of Tea Leaves)',
  },
  {
    ssic_code: '10765',
    title: 'Manufacture of Non-Dairy Creamer',
  },
  {
    ssic_code: '1079',
    title: 'Manufacture of Other Food Products n.e.c.',
  },
  {
    ssic_code: '10791',
    title:
      'Manufacture of Sauces Including Soya Bean Sauce (e.g. Tomato Sauce, Chilli Sauce)',
  },
  {
    ssic_code: '10792',
    title:
      'Manufacture of Soya Bean Products Except Soya Bean Sauce and Soya Bean Milk',
  },
  {
    ssic_code: '10793',
    title:
      'Manufacture and Processing of Spices (including Curry Powder and Spice Extracts)',
  },
  {
    ssic_code: '10794',
    title:
      'Manufacture of Chips, Crackers and Other Titbits (excluding Biscuits and Confectionery)',
  },
  {
    ssic_code: '10799',
    title:
      'Manufacture of Other Food Products n.e.c. (except Food Chemicals and Additives)',
  },
  {
    ssic_code: '1080',
    title: 'Manufacture of Prepared Animal Feeds',
  },
  {
    ssic_code: '10800',
    title:
      'Manufacture of Prepared Animal Feeds (including Additives for Animal Feed)',
  },
  {
    ssic_code: '11',
    title: 'Growing of Crops, Market Gardening and Horticulture',
  },
  {
    ssic_code: '110',
    title: 'Manufacture of Beverages',
  },
  {
    ssic_code: '1101',
    title: 'Distilling, Rectifying and Blending of Spirits',
  },
  {
    ssic_code: '11010',
    title:
      'Distilling, Rectifying and Blending of Spirits; Ethyl Alcohol Production From Fermented Materials (including Samsu and Chinese Liquors)',
  },
  {
    ssic_code: '11020',
    title: 'Manufacture of Wines',
  },
  {
    ssic_code: '1103',
    title: 'Manufacture of Malt Liquors and Malt',
  },
  {
    ssic_code: '11030',
    title: 'Manufacture of Malt Liquors and Malt (e.g. Beer and Stout)',
  },
  {
    ssic_code: '1104',
    title:
      'Manufacture of Soft Drinks, Production of Mineral Waters and Other Bottled Waters',
  },
  {
    ssic_code: '11041',
    title:
      'Manufacture of Soft Drinks, Production of Mineral Waters (including Carbonated Waters, Soya Bean Milk, Barley Water, Chrysanthemum Water)',
  },
  {
    ssic_code: '11042',
    title:
      'Manufacture of Cordials, Syrups and Composite Concentrates for Beverages',
  },
  {
    ssic_code: '11043',
    title: 'Manufacture of Ice Except Dry Ice',
  },
  {
    ssic_code: '111',
    title: 'Growing of Food Crops (non-Hydroponics)',
  },
  {
    ssic_code: '1111',
    title: 'Growing of Leafy and Fruit Vegetables',
  },
  {
    ssic_code: '1112',
    title: 'Growing of Mushrooms',
  },
  {
    ssic_code: '1113',
    title: 'Growing of Root Crops',
  },
  {
    ssic_code: '1119',
    title: 'Growing of Food Crops (non-Hydroponics) n.e.c.',
  },
  {
    ssic_code: '112',
    title: 'Growing of Food Crops (hydroponics)',
  },
  {
    ssic_code: '1120',
    title: 'Growing of Leafy and Fruit Vegetables (hydroponics)',
  },
  {
    ssic_code: '1130',
    title: 'Growing of Fruits',
  },
  {
    ssic_code: '114',
    title: 'Growing of Nursery Products',
  },
  {
    ssic_code: '1141',
    title: 'Growing of Orchids',
  },
  {
    ssic_code: '1142',
    title: 'Growing of Ornamental Plants',
  },
  {
    ssic_code: '1149',
    title: 'Growing of Nursery Products n.e.c.',
  },
  {
    ssic_code: '1190',
    title: 'Growing of Other Crops',
  },
  {
    ssic_code: '1200',
    title: 'Manufacture of Tobacco Products',
  },
  {
    ssic_code: '12001',
    title: 'Manufacture of Cigarettes',
  },
  {
    ssic_code: '12009',
    title:
      'Manufacture of Tobacco Products n.e.c. (e.g. Cigars, Loose Tobacco)',
  },
  {
    ssic_code: '13',
    title: 'Manufacture of Textiles',
  },
  {
    ssic_code: '13100',
    title: 'Spinning, Weaving and Finishing of Textiles',
  },
  {
    ssic_code: '139',
    title: 'Manufacture of Other Textiles',
  },
  {
    ssic_code: '1391',
    title: 'Manufacture of Knitted and Crocheted Fabrics',
  },
  {
    ssic_code: '13910',
    title: 'Manufacture of Knitted and Crocheted Fabrics and Laces',
  },
  {
    ssic_code: '1392',
    title: 'Manufacture of Made-Up Textile Articles Except Apparel',
  },
  {
    ssic_code: '13921',
    title: 'Manufacture of Curtains, Pillow Cases, Bed Sheets and Bed Spreads',
  },
  {
    ssic_code: '13922',
    title:
      'Manufacture of Other Made-Up House Furnishings (e.g. Napkins, Table Cloths)',
  },
  {
    ssic_code: '13929',
    title:
      'Manufacture of Made-Up Textile Articles Except Apparel n.e.c. (e.g. Scrolls, Flags and Sails, Banners, Canvas Products, Cushions, Pillows)',
  },
  {
    ssic_code: '13930',
    title: 'Manufacture of Carpets and Rugs',
  },
  {
    ssic_code: '13940',
    title: 'Manufacture of Cordage, Rope, Twine and Netting',
  },
  {
    ssic_code: '1399',
    title: 'Manufacture of Other Textiles n.e.c.',
  },
  {
    ssic_code: '13990',
    title: 'Manufacture of Other Textiles n.e.c. (e.g. Upholstery Filling)',
  },
  {
    ssic_code: '14',
    title: 'Animal Production',
  },
  {
    ssic_code: '14',
    title:
      'Manufacture of Wearing Apparel; Manufacture of Articles of Fur; Manufacture of Knitted and Crocheted Apparel',
  },
  {
    ssic_code: '141',
    title: 'Livestock Production (except Poultry and Animal Specialties)',
  },
  {
    ssic_code: '141',
    title: 'Manufacture of Wearing Apparel',
  },
  {
    ssic_code: '1410',
    title: 'Manufacture of Wearing Apparel Except Fur Apparel',
  },
  {
    ssic_code: '14101',
    title: 'Manufacture of Outer Garments',
  },
  {
    ssic_code: '14102',
    title: 'Manufacture of Brassieres and Other Undergarments',
  },
  {
    ssic_code: '14103',
    title: 'Tailoring and Dressmaking (to Individual Order)',
  },
  {
    ssic_code: '14109',
    title:
      'Manufacture of Wearing Apparel Except Fur Apparel n.e.c. (e.g. Songkoks, Caps, Gloves and Mittens, Garters, Handkerchiefs, Raincoats, Shawls and Hair Nets)',
  },
  {
    ssic_code: '1411',
    title: 'Pig Farms',
  },
  {
    ssic_code: '1412',
    title: 'Cattle Farms (including Dairy Cattle)',
  },
  {
    ssic_code: '1413',
    title: "Goat Farms (including Goat's Milk Production)",
  },
  {
    ssic_code: '142',
    title: 'Poultry Farms and Hatcheries',
  },
  {
    ssic_code: '1420',
    title: 'Manufacture of Articles of Fur',
  },
  {
    ssic_code: '14200',
    title:
      'Manufacture of Fur Apparel and Articles of Fur (e.g. Fur Rugs, Mats and Cushions)',
  },
  {
    ssic_code: '1421',
    title: 'Poultry Breeding/hatcheries',
  },
  {
    ssic_code: '1422',
    title: 'Broiler Farms (chickens Reared for Meat)',
  },
  {
    ssic_code: '1423',
    title: 'Layer Farms (chickens Reared for Eggs)',
  },
  {
    ssic_code: '1424',
    title: 'Duck Farms',
  },
  {
    ssic_code: '1430',
    title: 'Manufacture of Knitted and Crocheted Apparel',
  },
  {
    ssic_code: '14301',
    title: 'Manufacture of Socks, Stockings and Other Hosiery',
  },
  {
    ssic_code: '14302',
    title:
      'Manufacture of Briefs, Singlets and Other Knitted or Crocheted Wear (e.g. Pullovers, Cardigans)',
  },
  {
    ssic_code: '14309',
    title: 'Manufacture of Knitted and Crocheted Apparel n.e.c.',
  },
  {
    ssic_code: '149',
    title: 'Other Animal Production',
  },
  {
    ssic_code: '1491',
    title: 'Dog Breeding',
  },
  {
    ssic_code: '1492',
    title: 'Bird Breeding',
  },
  {
    ssic_code: '1493',
    title: 'Crocodile Farms',
  },
  {
    ssic_code: '1494',
    title: 'Frog Farms',
  },
  {
    ssic_code: '1499',
    title: 'Other Animal Production n.e.c.',
  },
  {
    ssic_code: '15',
    title:
      'Tanning and Dressing of Leather; Dressing and Dyeing of Fur; Manufacture of Footwear',
  },
  {
    ssic_code: '1500',
    title: 'Growing of Crops Combined with Animal Production (mixed Farming)',
  },
  {
    ssic_code: '151',
    title: 'Tanning and Dressing of Leather; Dressing and Dyeing',
  },
  {
    ssic_code: '15110',
    title: 'Tanning and Dressing of Leather; Dressing and Dyeing of Fur',
  },
  {
    ssic_code: '1512',
    title:
      'Manufacture of Luggage, Handbags and the Like; Saddlery and Harness',
  },
  {
    ssic_code: '15121',
    title: 'Manufacture of Luggage, Bags, Brief Cases and the Like',
  },
  {
    ssic_code: '15122',
    title: 'Manufacture of Handbags',
  },
  {
    ssic_code: '15129',
    title:
      'Manufacture of Saddlery, Harness and Articles of Leather n.e.c. (e.g. Coin Purses, Key Cases)',
  },
  {
    ssic_code: '15200',
    title: 'Manufacture of Footwear',
  },
  {
    ssic_code: '16',
    title:
      'Manufacture of Wood and of Products of Wood and Cork, Except Furniture; Manufacture of Articles of Straw and Plaiting Materials',
  },
  {
    ssic_code: '160',
    title:
      'Agricultural and Animal Husbandry Service Activities (except Veterinary Activities)',
  },
  {
    ssic_code: '1600',
    title:
      'Agricultural and Animal Husbandry Service Activities Except Veterinary Activities',
  },
  {
    ssic_code: '1610',
    title: 'Sawmilling and Planing of Wood',
  },
  {
    ssic_code: '16101',
    title: 'Sawmilling',
  },
  {
    ssic_code: '16102',
    title: 'Preservation of Wood',
  },
  {
    ssic_code: '16109',
    title: 'Sawmilling and Planing of Wood n.e.c.',
  },
  {
    ssic_code: '162',
    title:
      'Manufacture of Products of Wood, Cork, Straw and Plaiting Materials',
  },
  {
    ssic_code: '1621',
    title: 'Manufacture of Veneer, Plywood and Wood-Based Panels',
  },
  {
    ssic_code: '16211',
    title: 'Manufacture of Plywood and Veneer',
  },
  {
    ssic_code: '16219',
    title:
      'Manufacture of Laminboard, Particle Board and Other Panels and Boards n.e.c.',
  },
  {
    ssic_code: '1629',
    title:
      'Manufacture of Other Products of Wood and Articles of Cork, Straw and Plaiting Materials',
  },
  {
    ssic_code: '16291',
    title:
      'Manufacture of Wooden Window, Door and Other Millwork, Except Prefabricated Wooden Building Structures',
  },
  {
    ssic_code: '16292',
    title:
      'Manufacture of Household and Kitchen Wooden Ware Except Wooden Footwear',
  },
  {
    ssic_code: '16293',
    title: 'Manufacture of Wooden Containers',
  },
  {
    ssic_code: '16294',
    title: 'Manufacture of Attap and Attap Products',
  },
  {
    ssic_code: '16295',
    title: 'Rattan Processing',
  },
  {
    ssic_code: '16299',
    title:
      'Manufacture of Other Products of Wood and Articles of Cork, Straw and Plaiting Materials n.e.c.',
  },
  {
    ssic_code: '170',
    title: 'Manufacture of Paper and Paper Products',
  },
  {
    ssic_code: '17010',
    title: 'Manufacture of Pulp, Paper and Paperboard',
  },
  {
    ssic_code: '1702',
    title:
      'Manufacture of Corrugated Paper and Paperboard and of Containers of Paper and Paperboard',
  },
  {
    ssic_code: '17021',
    title: 'Manufacture of Corrugated Paper and Paperboard',
  },
  {
    ssic_code: '17022',
    title: 'Manufacture of Containers and Boxes of Paper and Paperboard',
  },
  {
    ssic_code: '1709',
    title: 'Manufacture of Other Articles of Paper and Paperboard',
  },
  {
    ssic_code: '17091',
    title:
      'Manufacture of Joss Paper and Other Related Ceremonial Paper Products (including Effigies and Other Funeral Paper Goods and Chinese Lanterns)',
  },
  {
    ssic_code: '17092',
    title:
      'Manufacture of Sanitary Towels, Toilet Paper, Paper Towels, Disposable Diapers and Related Paper Products',
  },
  {
    ssic_code: '17093',
    title: 'Manufacture of Paper Cups, Plates and Utensils',
  },
  {
    ssic_code: '17094',
    title: 'Manufacture of Cards, Envelopes and Stationery, Unprinted',
  },
  {
    ssic_code: '17099',
    title:
      'Manufacture of Other Articles of Paper and Paperboard n.e.c. (e.g. Papier Mache, Wallpaper)',
  },
  {
    ssic_code: '18',
    title: 'Printing and Reproduction of Recorded Media',
  },
  {
    ssic_code: '181',
    title: 'Printing and Service Activities Related to Printing',
  },
  {
    ssic_code: '1811',
    title: 'Printing',
  },
  {
    ssic_code: '18111',
    title: 'Printing of Newspapers',
  },
  {
    ssic_code: '18112',
    title: 'Printing of Periodicals, Books and Magazines',
  },
  {
    ssic_code: '18113',
    title:
      'Commercial Printing (e.g. Printing of Brochures, Cards, Envelopes, Labels and Stationery)',
  },
  {
    ssic_code: '18114',
    title: 'Printing of Continuous and Fan-Fold Forms',
  },
  {
    ssic_code: '18115',
    title: 'Silk Screen Printing (including Metal Printing)',
  },
  {
    ssic_code: '18119',
    title: 'Printing n.e.c.',
  },
  {
    ssic_code: '1812',
    title: 'Service Activities Related to Printing',
  },
  {
    ssic_code: '18121',
    title: 'Bookbinding (e.g. Book Packaging)',
  },
  {
    ssic_code: '18122',
    title: 'Colour Separation',
  },
  {
    ssic_code: '18129',
    title:
      'Service Activities Related to Printing n.e.c. (including Plate-Making)',
  },
  {
    ssic_code: '1820',
    title: 'Reproduction of Recorded Media',
  },
  {
    ssic_code: '18200',
    title:
      'Reproduction of Recorded Media (including Reproduction of Phonograph Records, Recorded Magnetic Tapes, Compact Discs and Non-Customised Software)',
  },
  {
    ssic_code: '19',
    title: 'Manufacture of Coke and Refined Petroleum Products',
  },
  {
    ssic_code: '19100',
    title: 'Manufacture of Coke Oven Products',
  },
  {
    ssic_code: '1920',
    title: 'Manufacture of Refined Petroleum Products',
  },
  {
    ssic_code: '19201',
    title: 'Petroleum Refineries',
  },
  {
    ssic_code: '19202',
    title: 'Manufacture of Petroleum Lubricating Oil',
  },
  {
    ssic_code: '19209',
    title: 'Manufacture of Refined Petroleum Products n.e.c.',
  },
  {
    ssic_code: '20',
    title: 'Manufacture of Chemicals and Chemical Products',
  },
  {
    ssic_code: '2000',
    title: 'Forestry, Logging and Related Service Activities',
  },
  {
    ssic_code: '201',
    title:
      'Manufacture of Basic Chemicals, Fertilisers and Nitrogen Compounds, Plastics and Synthetic Rubber in Primary Forms',
  },
  {
    ssic_code: '2011',
    title: 'Manufacture of Basic Chemicals',
  },
  {
    ssic_code: '20111',
    title: 'Manufacture of Industrial Gases and Dry Ice',
  },
  {
    ssic_code: '20112',
    title: 'Manufacture of Basic Industrial Acids and Alkalis',
  },
  {
    ssic_code: '20113',
    title: 'Manufacture of Basic Chemicals Except Fertilisers and Nitrogen',
  },
  {
    ssic_code: '20114',
    title: 'Manufacture of Solvents',
  },
  {
    ssic_code: '20119',
    title: 'Manufacture of Basic Chemicals n.e.c.',
  },
  {
    ssic_code: '20120',
    title: 'Manufacture of Fertilisers and Nitrogen Compounds',
  },
  {
    ssic_code: '2013',
    title:
      'Manufacture of Petrochemicals; Plastic and Synthetic Rubber in Primary Forms',
  },
  {
    ssic_code: '20131',
    title:
      'Manufacture of Petrochemical Primary Products (e.g. Olefins, Aromatics, Basic Building Blocks)',
  },
  {
    ssic_code: '20132',
    title:
      'Manufacture of Derivatives and Intermediates Produced From Basic Building Blocks (e.g. Acetyls, Acrylics, Oxochemicals, Styrene, Phenolic, Ethylene Oxide Derivatives and Polymers)',
  },
  {
    ssic_code: '20133',
    title: 'Manufacture of Synthetic Rubber',
  },
  {
    ssic_code: '202',
    title: 'Manufacture of Other Chemical Products',
  },
  {
    ssic_code: '2021',
    title: 'Manufacture of Pesticides and Other Agro-Chemical Products',
  },
  {
    ssic_code: '20210',
    title:
      'Manufacture of Pesticides and Other Agro-Chemical Products (including Insecticides, Herbicides and Disinfectants)',
  },
  {
    ssic_code: '2022',
    title:
      'Manufacture of Paints, Varnishes and Similar Coatings, Printing Ink and Mastics',
  },
  {
    ssic_code: '20221',
    title: 'Manufacture of Paints',
  },
  {
    ssic_code: '20222',
    title: 'Manufacture of Varnishes and Lacquers (including Enamels)',
  },
  {
    ssic_code: '20229',
    title:
      'Manufacture of Paints, Varnishes and Similar Coatings and Mastics n.e.c.',
  },
  {
    ssic_code: '2023',
    title:
      'Manufacture of Soap and Detergents, Cleaning and Polishing Preparations, Perfumes and Toilet Preparations',
  },
  {
    ssic_code: '20231',
    title:
      'Manufacture of Soap, Detergents, Washing and Other Cleaning Preparations',
  },
  {
    ssic_code: '20232',
    title: 'Manufacture of Perfumes and Fragrances',
  },
  {
    ssic_code: '20233',
    title: 'Manufacture of Cosmetics and Toiletries',
  },
  {
    ssic_code: '20234',
    title: 'Manufacture of Waxes and Polishes and Deodorising Preparations',
  },
  {
    ssic_code: '2024',
    title: 'Manufacture of Additives',
  },
  {
    ssic_code: '20241',
    title:
      'Manufacture of Food Chemicals and Additives (e.g. Flavours, Preservatives and Colourings)',
  },
  {
    ssic_code: '20242',
    title:
      'Manufacture of Additives for Mineral Oil (e.g. Lubricant and Fuel Additives)',
  },
  {
    ssic_code: '20249',
    title: 'Manufacture of Additives n.e.c.',
  },
  {
    ssic_code: '2029',
    title: 'Manufacture of Other Chemical Products n.e.c.',
  },
  {
    ssic_code: '20291',
    title:
      'Manufacture of Epoxy Moulding Compounds and Phenolic Moulding Compounds',
  },
  {
    ssic_code: '20292',
    title:
      'Manufacture of Ultrapure Electronic Chemicals, Materials and Laminates',
  },
  {
    ssic_code: '20293',
    title:
      'Manufacture of Water Treatment, Waste Treatment and Oilfield Chemicals',
  },
  {
    ssic_code: '20294',
    title: 'Manufacture of Inks, Dyestuffs, Pigments and Carbon Black',
  },
  {
    ssic_code: '20295',
    title: 'Manufacture of Photographic Film, Paper, Plate and Chemicals',
  },
  {
    ssic_code: '20296',
    title: 'Manufacture of Adhesives and Sealants',
  },
  {
    ssic_code: '20297',
    title: 'Manufacture of Catalysts and Catalyst Regeneration',
  },
  {
    ssic_code: '20298',
    title: 'Manufacture of Biofuels',
  },
  {
    ssic_code: '20299',
    title:
      'Manufacture of Other Chemical Products n.e.c. (e.g. Gelatin and Derivatives, Laundry Blue, Explosives, Processed Salts, Industrial Starch, Incense and Joss Sticks, Camphor Products)',
  },
  {
    ssic_code: '2030',
    title: 'Manufacture of Man-Made Fibres',
  },
  {
    ssic_code: '20300',
    title: 'Manufacture of Man-Made Fibres Except Glass',
  },
  {
    ssic_code: '210',
    title: 'Manufacture of Pharmaceuticals and Biological Products',
  },
  {
    ssic_code: '2101',
    title: 'Manufacture of Pharmaceutical Products',
  },
  {
    ssic_code: '21011',
    title:
      'Manufacture of Pharmaceutical Intermediates and Fine Chemicals for Human Use',
  },
  {
    ssic_code: '21012',
    title:
      'Manufacture of Pharmaceutical Products and Preparations for Human Use (e.g. Tableted Products)',
  },
  {
    ssic_code: '21013',
    title: 'Manufacture of Pharmaceutical Products for Veterinary Use',
  },
  {
    ssic_code: '2102',
    title: 'Manufacture of Biological Products',
  },
  {
    ssic_code: '21021',
    title: 'Manufacture of Vaccines for Human Use',
  },
  {
    ssic_code: '21022',
    title:
      'Manufacture of Other Biological Products and Preparations for Human Use',
  },
  {
    ssic_code: '21023',
    title:
      'Manufacture of Biological Products and Preparations for Veterinary Use',
  },
  {
    ssic_code: '21030',
    title: 'Manufacture of Traditional Chinese Medicine',
  },
  {
    ssic_code: '22',
    title: 'Manufacture of Rubber and Plastic Products',
  },
  {
    ssic_code: '221',
    title: 'Manufacture of Rubber Products',
  },
  {
    ssic_code: '2211',
    title: 'Processing of Natural Rubber and Gums',
  },
  {
    ssic_code: '22111',
    title: 'Processing of Rubber (including Processing of Rubber Latex)',
  },
  {
    ssic_code: '22112',
    title: 'Grading and Packing of Rubber',
  },
  {
    ssic_code: '22119',
    title: 'Processing of Natural Gums n.e.c. (e.g. Gum Damar, Jelutong)',
  },
  {
    ssic_code: '2212',
    title:
      'Manufacture of Rubber Tyres and Tubes, Retreading and Rebuilding of Rubber Tyres',
  },
  {
    ssic_code: '22121',
    title: 'Manufacture of Tyres and Tubes',
  },
  {
    ssic_code: '22122',
    title: 'Retreading and Vulcanising of Tyres',
  },
  {
    ssic_code: '2219',
    title:
      'Manufacture of Other Rubber Products Except Rubber Footwear and Toys',
  },
  {
    ssic_code: '22191',
    title:
      'Manufacture of Foam Rubber Products (excluding Foam Rubber Mattresses)',
  },
  {
    ssic_code: '22192',
    title: 'Manufacture of Rubber Automotive Parts',
  },
  {
    ssic_code: '22193',
    title: 'Manufacture of Industrial and Mechanical Rubber Goods',
  },
  {
    ssic_code: '22194',
    title: 'Manufacture of Rubber Floorings',
  },
  {
    ssic_code: '22199',
    title:
      'Manufacture of Other Rubber Products n.e.c. (except Rubber Footwear and Toys)',
  },
  {
    ssic_code: '222',
    title: 'Manufacture of Plastic Products',
  },
  {
    ssic_code: '2221',
    title: 'Manufacture of Plastic Products Except Plastic Footwear and Toys',
  },
  {
    ssic_code: '22211',
    title:
      'Manufacture of Plastic Tableware, Household and Kitchen Ware (excluding Disposable Utensils)',
  },
  {
    ssic_code: '22212',
    title: 'Manufacture of Styrofoam and Plastic Disposable Utensils',
  },
  {
    ssic_code: '22213',
    title:
      'Manufacture of Plastic Sheet, Film and Articles Thereof (e.g. Polythene and Polypropylene Bags)',
  },
  {
    ssic_code: '22214',
    title:
      'Manufacture of Plastic Bottles, Boxes and Containers (except for Household Use)',
  },
  {
    ssic_code: '22215',
    title: 'Manufacture of Plastic Pipes and Tubes',
  },
  {
    ssic_code: '22216',
    title: 'Manufacture of Plastic Precision Engineering Parts',
  },
  {
    ssic_code: '22217',
    title: 'Manufacture of Pvc Files, Holders and Albums',
  },
  {
    ssic_code: '22218',
    title: 'Manufacture of Plastic Cable Ties',
  },
  {
    ssic_code: '22219',
    title:
      'Manufacture of Plastic Products n.e.c. (except Plastic Footwear and Toys)',
  },
  {
    ssic_code: '22220',
    title: 'Plastic Product Services',
  },
  {
    ssic_code: '23',
    title: 'Manufacture of Other Non-Metallic Mineral Products',
  },
  {
    ssic_code: '2310',
    title: 'Manufacture of Glass and Glass Products',
  },
  {
    ssic_code: '23100',
    title:
      'Manufacture of Glass and Glass Products (including Yarn of Glass Fibres)',
  },
  {
    ssic_code: '2391',
    title: 'Manufacture of Clay Products',
  },
  {
    ssic_code: '23911',
    title: 'Manufacture of Bricks',
  },
  {
    ssic_code: '23912',
    title:
      'Manufacture of Tiles, Pipes and Channels (including Clay Roofing, Wall and Floor Tiles, and Earthen and Glazed Pipes)',
  },
  {
    ssic_code: '23919',
    title: 'Manufacture of Clay Products n.e.c.',
  },
  {
    ssic_code: '2393',
    title: 'Manufacture of Other Porcelain and Ceramic Products',
  },
  {
    ssic_code: '23931',
    title:
      'Manufacture of Plumbing Fixtures and Fittings of Vitreous China, China and Earthenware (e.g. Sinks, Closets, Bowls)',
  },
  {
    ssic_code: '23939',
    title: 'Manufacture of Other Porcelain and Ceramic Products n.e.c.',
  },
  {
    ssic_code: '23940',
    title: 'Manufacture of Cement, Lime and Plaster',
  },
  {
    ssic_code: '2395',
    title: 'Manufacture of Articles of Concrete, Cement and Plaster',
  },
  {
    ssic_code: '23951',
    title: 'Manufacture of Ready-Mix Concrete',
  },
  {
    ssic_code: '23959',
    title:
      'Manufacture of Articles of Concrete, Cement and Plaster n.e.c. (except Precast Concrete Components)',
  },
  {
    ssic_code: '2396',
    title: 'Cutting, Shaping and Finishing of Stone',
  },
  {
    ssic_code: '23960',
    title:
      'Cutting, Shaping and Finishing of Stone (including Tomb-Stones and Furniture of Stone or Marble)',
  },
  {
    ssic_code: '2399',
    title: 'Manufacture of Other Non-Metallic Mineral Products n.e.c.',
  },
  {
    ssic_code: '23991',
    title: 'Manufacture of Asbestos Products Except Asbestos Paper',
  },
  {
    ssic_code: '23992',
    title: 'Manufacture of Fibreglass and Fibreglass Products',
  },
  {
    ssic_code: '23993',
    title:
      'Manufacture of Other Insulation Products (e.g. Ceramic Ic Packages, Refractory Materials, Rock Wool Products, Insulation Services)',
  },
  {
    ssic_code: '23994',
    title:
      'Manufacture of Non-Structural Pre-Cast Components (e.g. Lightweight Partitions, Secondary Roof Slabs)',
  },
  {
    ssic_code: '23995',
    title: 'Manufacture of Asphalt Premix',
  },
  {
    ssic_code: '23999',
    title:
      'Manufacture of Other Non-Metallic Mineral Products n.e.c. (e.g. Graphite Products)',
  },
  {
    ssic_code: '24',
    title: 'Manufacture of Basic Metals',
  },
  {
    ssic_code: '2410',
    title: 'Manufacture of Basic Iron and Steel',
  },
  {
    ssic_code: '24101',
    title: 'Iron and Steel Rolling Mills',
  },
  {
    ssic_code: '24102',
    title: 'Manufacture of Ferrous Metal Alloys',
  },
  {
    ssic_code: '24109',
    title: 'Manufacture of Basic Iron and Steel n.e.c. (including Smelting)',
  },
  {
    ssic_code: '2420',
    title: 'Manufacture of Basic Precious and Non-Ferrous Metals',
  },
  {
    ssic_code: '24201',
    title: 'Tin Smelting',
  },
  {
    ssic_code: '24202',
    title: 'Manufacture of Non-Ferrous Metal Alloys',
  },
  {
    ssic_code: '24209',
    title: 'Manufacture of Basic Precious and Non-Ferrous Metals n.e.c.',
  },
  {
    ssic_code: '243',
    title: 'Casting of Metals',
  },
  {
    ssic_code: '2431',
    title: 'Casting of Iron and Steel',
  },
  {
    ssic_code: '24310',
    title: 'Iron and Steel Foundries',
  },
  {
    ssic_code: '2432',
    title: 'Casting of Non-Ferrous Metals',
  },
  {
    ssic_code: '24320',
    title: 'Non-Ferrous Metal Foundries',
  },
  {
    ssic_code: '25',
    title:
      'Manufacture of Fabricated Metal Products Except Machinery and Equipment',
  },
  {
    ssic_code: '251',
    title:
      'Manufacture of Structural Metal Products, Tanks, Reservoirs and Steam Generators',
  },
  {
    ssic_code: '2511',
    title: 'Manufacture of Structural Metal Products',
  },
  {
    ssic_code: '25111',
    title:
      'Manufacture of Metal Doors, Window and Door Frames, Grilles and Gratings',
  },
  {
    ssic_code: '25112',
    title: 'Manufacture of Metal Strips and Slabs (e.g. Awnings)',
  },
  {
    ssic_code: '25113',
    title: 'Manufacture of Metal Pipes and Tubes',
  },
  {
    ssic_code: '25114',
    title: 'Manufacture of Steel Structural Component',
  },
  {
    ssic_code: '25119',
    title:
      'Manufacture of Structural Metal Products n.e.c. (e.g. Metal Sections, Corrugated Sheets)',
  },
  {
    ssic_code: '2512',
    title:
      'Manufacture and Repair of Tanks, Reservoirs and Containers of Metal',
  },
  {
    ssic_code: '25120',
    title:
      'Manufacture and Repair of Tanks, Reservoirs and Containers of Metal (e.g. Metal Cylinders, Storage Vessels and Containers for Compressed or Liquefied Gas)',
  },
  {
    ssic_code: '2513',
    title:
      'Manufacture and Repair of Steam Generators Except Central Heating Hot Water Boilers',
  },
  {
    ssic_code: '25131',
    title:
      'Manufacture and Repair of Heating Boilers, Radiators and Correctors (including Parts)',
  },
  {
    ssic_code: '25139',
    title:
      'Manufacture and Repair of Steam Generators n.e.c. (except Central Heating Hot Water Boilers)',
  },
  {
    ssic_code: '252',
    title: 'Manufacture of Weapons and Ammunition',
  },
  {
    ssic_code: '2520',
    title: 'Manufacture and Repair of Weapons and Ammunition',
  },
  {
    ssic_code: '25200',
    title:
      'Manufacture and Repair of Weapons and Ammunition (e.g. Ordnance and Accessories)',
  },
  {
    ssic_code: '259',
    title:
      'Manufacture of Other Fabricated Metal Products; Metalworking Service Activities',
  },
  {
    ssic_code: '2591',
    title:
      'Forging, Pressing, Stamping and Roll-Forming of Metal; Powder Metallurgy',
  },
  {
    ssic_code: '25911',
    title: 'Iron and Steel and Non-Ferrous Forgings',
  },
  {
    ssic_code: '25912',
    title: 'Manufacture of Metal Caps (e.g. Crown Corks)',
  },
  {
    ssic_code: '25913',
    title: 'Manufacture of Leadframe',
  },
  {
    ssic_code: '25914',
    title: 'Metal Stampings Except Metal Caps',
  },
  {
    ssic_code: '25919',
    title: 'Pressing and Roll-Forming of Metal and Powder Metallurgy n.e.c.',
  },
  {
    ssic_code: '2592',
    title: 'Treatment and Coating of Metals',
  },
  {
    ssic_code: '25921',
    title: 'Electroplating and Plating of Metals and Formed Products',
  },
  {
    ssic_code: '25922',
    title: 'Polishing of Metals and Formed Products',
  },
  {
    ssic_code: '25923',
    title: 'Rustproofing of Metals and Formed Products',
  },
  {
    ssic_code: '25924',
    title: 'Heat Treatment for Metals',
  },
  {
    ssic_code: '25929',
    title: 'Metal Product Services n.e.c.',
  },
  {
    ssic_code: '2593',
    title: 'Manufacture of Cutlery, Hand Tools and General Hardware',
  },
  {
    ssic_code: '25931',
    title: 'Manufacture of Table, Kitchen and Other Cutlery',
  },
  {
    ssic_code: '25932',
    title: 'Manufacture of Hand and Edge Tools',
  },
  {
    ssic_code: '25939',
    title:
      'Manufacture of General Hardware (including Blacksmith Shops) n.e.c. (e.g. Locks and Keys, Hinges, Clamps, Hooks)',
  },
  {
    ssic_code: '2594',
    title: 'Manufacture of Metal Wire and Cable Products',
  },
  {
    ssic_code: '25941',
    title:
      'Manufacture of Uninsulated Wire (e.g. Electronic Component Wire, Bonding Wire)',
  },
  {
    ssic_code: '25949',
    title: 'Manufacture of Metal Wire and Cable Products n.e.c.',
  },
  {
    ssic_code: '2595',
    title: 'Manufacture of Metal Cans, Containers and Related Products',
  },
  {
    ssic_code: '25951',
    title: 'Manufacture of Tinplate Cans',
  },
  {
    ssic_code: '25952',
    title:
      'Manufacture of Other Tinplate and Zinc Articles (e.g. Pails, Buckets, Dustbins)',
  },
  {
    ssic_code: '25959',
    title:
      'Manufacture of Metal Cans, Containers and Related Products n.e.c. (e.g. Barrels, Steel Drums, Kegs)',
  },
  {
    ssic_code: '2599',
    title: 'Manufacture of Other Fabricated Metal Products n.e.c.',
  },
  {
    ssic_code: '25991',
    title:
      "Manufacture of Sanitary Ware of Enamelled Iron and Metal and Plumbers' Ware of Brass",
  },
  {
    ssic_code: '25992',
    title:
      'Manufacture of Plumbing, Heating and Related Products (including Parts) Except Electric',
  },
  {
    ssic_code: '25993',
    title:
      'Manufacture of Bolts, Nuts, Rivets, Fasteners and Screw Machine Products',
  },
  {
    ssic_code: '25994',
    title: 'Manufacture of Pipe Fittings',
  },
  {
    ssic_code: '25995',
    title: 'Manufacture of Springs',
  },
  {
    ssic_code: '25996',
    title:
      'Manufacture of Kitchen and Household Utensils (e.g. Steel Shelf, Showcase Counters, Kitchen Trolleys Display Racks, Sink Bowls and Other Customised Kitchen Equipment)',
  },
  {
    ssic_code: '25997',
    title: 'Manufacture of Metal Precision Components',
  },
  {
    ssic_code: '25998',
    title: 'Slitting, Shearing and Pasting of Metal Sheeting',
  },
  {
    ssic_code: '25999',
    title:
      'Manufacture of Other Fabricated Metal Products n.e.c. (including Voice Coil Magnets)',
  },
  {
    ssic_code: '26',
    title: 'Manufacture of Computer, Electronic and Optical Products',
  },
  {
    ssic_code: '261',
    title: 'Manufacture of Electronic Components and Boards',
  },
  {
    ssic_code: '2611',
    title: 'Manufacture of Semiconductor Devices',
  },
  {
    ssic_code: '26111',
    title:
      'Manufacture of Discrete Devices (e.g. Diodes, Light-Emitting Diodes, Transistors and Rectifiers)',
  },
  {
    ssic_code: '26112',
    title: 'Semiconductor Wafer Fabrication',
  },
  {
    ssic_code: '26113',
    title: 'Assembly and Testing of Semiconductors',
  },
  {
    ssic_code: '26114',
    title: 'Manufacture of Solar Wafers',
  },
  {
    ssic_code: '26115',
    title: 'Manufacture of Solar Cells',
  },
  {
    ssic_code: '26119',
    title: 'Manufacture of Semiconductor Devices n.e.c.',
  },
  {
    ssic_code: '2612',
    title: 'Manufacture of Other Electronic Components and Boards',
  },
  {
    ssic_code: '26121',
    title: 'Manufacture of Capacitors',
  },
  {
    ssic_code: '26122',
    title: 'Manufacture of Printed Circuit Boards Without Electronic Parts',
  },
  {
    ssic_code: '26123',
    title: 'Manufacture of Printed Circuit Boards with Electronic Parts',
  },
  {
    ssic_code: '26124',
    title:
      'Manufacture of Piezo-Electric Devices (e.g. Quartz Crystals, Quartz Crystal Filters, Delay Lines)',
  },
  {
    ssic_code: '26125',
    title:
      'Manufacture of Electronic Display Devices Except Light Emitting Diodes',
  },
  {
    ssic_code: '26126',
    title: 'Manufacture of Electronic Connectors',
  },
  {
    ssic_code: '26129',
    title: 'Manufacture of Other Electronic Components and Boards n.e.c.',
  },
  {
    ssic_code: '2620',
    title: 'Manufacture of Computers and Peripheral Equipment',
  },
  {
    ssic_code: '26201',
    title:
      'Manufacture of Computers and Data Processing Equipment Except Computer Peripheral Equipment',
  },
  {
    ssic_code: '26202',
    title:
      'Manufacture of Disk Drives (including Cd-Rom Drives, Dvd-Rom Drives, Optical Drives, Flash Drives, Tape Drives, Solid State Drives, Storage Subsystems)',
  },
  {
    ssic_code: '26203',
    title: 'Manufacture of Printers',
  },
  {
    ssic_code: '26204',
    title:
      'Manufacture of Smart Cards and Related Products (e.g. Smart Card Readers)',
  },
  {
    ssic_code: '26209',
    title: 'Manufacture of Computers and Peripheral Equipment n.e.c.',
  },
  {
    ssic_code: '2630',
    title: 'Manufacture of Communications Equipment',
  },
  {
    ssic_code: '26301',
    title:
      'Manufacture of Telecommunications Apparatus (e.g. Pbx Equipment, Telephones Except Cellular)',
  },
  {
    ssic_code: '26302',
    title: 'Manufacture of Networking Products (e.g. Routers, Switches)',
  },
  {
    ssic_code: '26303',
    title:
      'Manufacture of Wireless Communications Equipment (e.g. Cellular Phones)',
  },
  {
    ssic_code: '26304',
    title:
      'Manufacture of Electronic Security Systems (including Electronic Sensors, Burglar and Fire Alarm Systems)',
  },
  {
    ssic_code: '26309',
    title: 'Manufacture of Communications Equipment n.e.c.',
  },
  {
    ssic_code: '26400',
    title: 'Manufacture of Consumer Electronics',
  },
  {
    ssic_code: '265',
    title:
      'Manufacture of Measuring, Testing, Navigating and Control Equipment; Watches and Clocks',
  },
  {
    ssic_code: '2651',
    title:
      'Manufacture and Repair of Measuring, Testing, Navigating and Control Equipment',
  },
  {
    ssic_code: '26511',
    title: 'Manufacture and Repair of Engineering and Scientific Instruments',
  },
  {
    ssic_code: '26512',
    title: 'Manufacture and Repair of Measuring Devices (e.g. Meters)',
  },
  {
    ssic_code: '26513',
    title:
      'Manufacture and Repair of Process Control Equipment and Related Products',
  },
  {
    ssic_code: '2652',
    title: 'Manufacture of Watches and Clocks',
  },
  {
    ssic_code: '26521',
    title: 'Manufacture of Fully Electronic Watches and Clocks',
  },
  {
    ssic_code: '26522',
    title:
      'Manufacture of Electro-Mechanical Watches and Clocks (e.g. Watches and Clocks with Moving Parts and Battery)',
  },
  {
    ssic_code: '26523',
    title: 'Manufacture of Mechanical Watches and Clocks',
  },
  {
    ssic_code: '26524',
    title: 'Manufacture of Parts and Accessories for Watches and Clocks',
  },
  {
    ssic_code: '266',
    title:
      'Manufacture of Irradiation, Electromedical and Electrotherapeutic Equipment',
  },
  {
    ssic_code: '2660',
    title:
      'Manufacture and Repair of Irradiation, Electromedical and Electrotherapeutic Equipment',
  },
  {
    ssic_code: '26601',
    title: 'Manufacture and Repair of Electrotherapeutic Devices',
  },
  {
    ssic_code: '26602',
    title:
      'Manufacture and Repair of Irradiation and Electromedical Equipment and Instruments',
  },
  {
    ssic_code: '2670',
    title: 'Manufacture of Optical Instruments and Photographic Equipment',
  },
  {
    ssic_code: '26701',
    title: 'Manufacture of Photographic Equipment and Parts (including Lenses)',
  },
  {
    ssic_code: '26709',
    title:
      'Manufacture of Optical Instruments and Photographic Equipment n.e.c.',
  },
  {
    ssic_code: '2680',
    title: 'Manufacture of Magnetic and Optical Media',
  },
  {
    ssic_code: '26801',
    title: 'Manufacture of Disk Media',
  },
  {
    ssic_code: '26802',
    title:
      'Manufacture of Blank Magnetic Tapes, Diskettes, Blu-Ray Technology Discs, Cds, Dvds and Vcds',
  },
  {
    ssic_code: '27',
    title: 'Manufacture of Electrical Equipment',
  },
  {
    ssic_code: '271',
    title:
      'Manufacture of Electric Motors, Generators, Transformers, Electricity Distribution and Control Apparatus',
  },
  {
    ssic_code: '2710',
    title:
      'Manufacture and Repair of Electric Motors, Generators, Transformers, Electricity Distribution and Control Apparatus',
  },
  {
    ssic_code: '27101',
    title: 'Manufacture and Repair of Electric Motors',
  },
  {
    ssic_code: '27102',
    title: 'Manufacture and Repair of Electric Generators',
  },
  {
    ssic_code: '27103',
    title: 'Manufacture and Repair of Transformers',
  },
  {
    ssic_code: '27104',
    title:
      'Manufacture and Repair of Switchgear and Switchboard Apparatus (including Switches, Circuit Breakers and Electrical Control Panels)',
  },
  {
    ssic_code: '27109',
    title:
      'Manufacture and Repair of Electric Motors, Generators, Transformers and Electricity Distribution and Control Apparatus n.e.c. (e.g. Busbar Trunking)',
  },
  {
    ssic_code: '2720',
    title: 'Manufacture of Batteries and Accumulators',
  },
  {
    ssic_code: '27201',
    title: 'Manufacture of Primary Batteries',
  },
  {
    ssic_code: '27202',
    title: 'Manufacture of Secondary Batteries',
  },
  {
    ssic_code: '273',
    title: 'Manufacture of Wiring and Wiring Devices',
  },
  {
    ssic_code: '2732',
    title: 'Manufacture of Electronic and Electric Wires and Cables',
  },
  {
    ssic_code: '27321',
    title: 'Manufacture of Telecommunications Cables and Wires',
  },
  {
    ssic_code: '27322',
    title: 'Manufacture of Electric Power Cables and Wires',
  },
  {
    ssic_code: '27323',
    title:
      'Manufacture of Enamelled Wires (used for Winding of Motors, Transformers Etc)',
  },
  {
    ssic_code: '27324',
    title: 'Manufacture of Wire and Cable Assemblies and Harnesses',
  },
  {
    ssic_code: '27329',
    title:
      'Manufacture of Other Electronic and Electric Wires and Cables n.e.c.',
  },
  {
    ssic_code: '27330',
    title: 'Manufacture and Repair of Wiring Devices',
  },
  {
    ssic_code: '274',
    title: 'Manufacture of Electric Lighting Equipment',
  },
  {
    ssic_code: '2740',
    title: 'Manufacture and Repair of Electric Lighting Equipment',
  },
  {
    ssic_code: '27400',
    title:
      'Manufacture and Repair of Electric Lamps and Lighting Equipment (including Silver Reflectors, Fittings and Parts)',
  },
  {
    ssic_code: '2750',
    title: 'Manufacture of Domestic Appliances',
  },
  {
    ssic_code: '27501',
    title:
      'Manufacture of Electrical Household Appliances (e.g. Refrigerators, Hot Plates, Toasters, Food Mixers, Cookers, Hair Dryers, Fans, Shavers)',
  },
  {
    ssic_code: '27509',
    title:
      'Manufacture of Domestic Appliances n.e.c. (e.g. Non-Electric Cooking Ranges, Grates, Stoves)',
  },
  {
    ssic_code: '2790',
    title: 'Manufacture of Other Electrical Equipment',
  },
  {
    ssic_code: '27901',
    title: 'Manufacture of Fuel Cells',
  },
  {
    ssic_code: '27902',
    title:
      'Manufacture of Electrical Machinery, Apparatus, Appliances and Supplies (including Sound or Visual Signalling Apparatus, Electrical Insulators Except Porcelain or Glass)',
  },
  {
    ssic_code: '28',
    title: 'Manufacture of Machinery and Equipment',
  },
  {
    ssic_code: '281',
    title: 'Manufacture of General Purpose Machinery',
  },
  {
    ssic_code: '2811',
    title:
      'Manufacture and Repair of Engines and Turbines Except Aircraft, Vehicle and Cycle Engines',
  },
  {
    ssic_code: '28111',
    title:
      'Manufacture and Repair of Engines and Turbines Except Aircraft, Vehicle, Cycle and Marine Engines',
  },
  {
    ssic_code: '28112',
    title: 'Manufacture and Repair of Marine Engine',
  },
  {
    ssic_code: '2812',
    title: 'Manufacture and Repair of Pumps, Compressors, Taps and Valves',
  },
  {
    ssic_code: '28121',
    title:
      'Manufacture and Repair of Pumps (e.g. Hydraulic Pumps, Drainage Pumps)',
  },
  {
    ssic_code: '28122',
    title: 'Manufacture and Repair of Taps, Cocks and Valves',
  },
  {
    ssic_code: '28129',
    title:
      'Manufacture and Repair of Pumps, Compressors, Taps and Valves n.e.c.',
  },
  {
    ssic_code: '2814',
    title: 'Manufacture of Bearings, Gears, Gearing and Driving Elements',
  },
  {
    ssic_code: '28141',
    title: 'Manufacture of Bearings (including Disc and Ball Bearings)',
  },
  {
    ssic_code: '28142',
    title: 'Manufacture and Repair of Gears, Gearing and Driving Elements',
  },
  {
    ssic_code: '28150',
    title: 'Manufacture and Repair of Ovens, Furnaces and Furnace Burners',
  },
  {
    ssic_code: '2816',
    title: 'Manufacture and Repair of Lifting and Handling Equipment',
  },
  {
    ssic_code: '28161',
    title:
      'Manufacture and Repair of Lifting and Hoisting Machinery Except Electrical',
  },
  {
    ssic_code: '28162',
    title: 'Manufacture and Repair of Lifts and Escalators',
  },
  {
    ssic_code: '28169',
    title:
      'Manufacture and Repair of Lifting and Handling Equipment n.e.c. (including Conveying Systems and Industrial Automated Systems)',
  },
  {
    ssic_code: '2817',
    title:
      'Manufacture and Repair of Office Machinery and Equipment (except Computers and Peripheral Equipment)',
  },
  {
    ssic_code: '28171',
    title:
      'Manufacture of Office Machinery and Equipment (except Computers and Peripheral Equipment)',
  },
  {
    ssic_code: '28172',
    title: 'Repair and Maintenance of Office Machinery and Equipment',
  },
  {
    ssic_code: '2818',
    title: 'Manufacture and Repair of Robots',
  },
  {
    ssic_code: '28181',
    title:
      'Manufacture and Repair of Industrial Robots (including Automated Guided Vehicles (agvs))',
  },
  {
    ssic_code: '28182',
    title: 'Manufacture and Repair of Service Robots',
  },
  {
    ssic_code: '28189',
    title: 'Manufacture and Repair of Robots n.e.c.',
  },
  {
    ssic_code: '2819',
    title: 'Manufacture and Repair of Other General Purpose Machinery',
  },
  {
    ssic_code: '28191',
    title:
      'Manufacture and Repair of Refrigerating, Air-Conditioning and Ventilating Machinery and Equipment Except Household Refrigerators',
  },
  {
    ssic_code: '28192',
    title:
      'Manufacture and Repair of Separation/mixing Equipment (e.g. Filters, Separators, Mixers)',
  },
  {
    ssic_code: '28193',
    title: 'Manufacture and Repair of Solar Modules and Panels',
  },
  {
    ssic_code: '28194',
    title:
      'Manufacture and Repair of Welding and Soldering Equipment (including Arc Welding Electrodes)',
  },
  {
    ssic_code: '28195',
    title: 'Manufacture and Repair of Packaging Machinery',
  },
  {
    ssic_code: '28199',
    title:
      'Manufacture and Repair of Other General Purpose Machinery and Equipment Except Electrical and Electronic n.e.c.',
  },
  {
    ssic_code: '282',
    title: 'Manufacture of Special Purpose Machinery',
  },
  {
    ssic_code: '28210',
    title: 'Manufacture and Repair of Agricultural and Forestry Machinery',
  },
  {
    ssic_code: '2822',
    title:
      'Manufacture and Repair of Metal-Forming Machinery and Machine Tools',
  },
  {
    ssic_code: '28221',
    title:
      'Manufacture and Repair of Machinery and Machine-Tools - Metal Cutting Types (e.g. Lathes, Milling Machines, Shaping Machines)',
  },
  {
    ssic_code: '28222',
    title:
      'Manufacture and Repair of Machinery and Machine-Tools - Metal Forming Types (e.g. Forging Press, Cold Heading Machines, Press Breaks)',
  },
  {
    ssic_code: '28223',
    title: 'Manufacture of Dies, Moulds, Tools, Jigs and Fixtures',
  },
  {
    ssic_code: '28224',
    title:
      'Manufacture of Machine Tool Accessories (e.g. Small Cutting Tools, Precision Measuring Tools and Other Attachments Such As Tool Holders)',
  },
  {
    ssic_code: '28225',
    title:
      'Manufacture and Repair of Metal Additive Manufacturing (am) Equipment (including Metal Powder)',
  },
  {
    ssic_code: '28229',
    title:
      'Manufacture and Repair of Metal-Forming Machinery and Machine Tools n.e.c. (including Metalworking Machinery)',
  },
  {
    ssic_code: '2824',
    title:
      'Manufacture and Repair of Machinery for Mining, Quarrying and Construction',
  },
  {
    ssic_code: '28241',
    title: 'Manufacture and Repair of Oil Rigs',
  },
  {
    ssic_code: '28242',
    title:
      'Manufacture and Repair of Other Oilfield and Gasfield Machinery and Equipment (e.g. Derricks, Tool Joints)',
  },
  {
    ssic_code: '28243',
    title: 'Manufacture and Repair of Construction Machinery and Parts',
  },
  {
    ssic_code: '28249',
    title:
      'Manufacture and Repair of Machinery for Mining, Quarrying and Construction n.e.c.',
  },
  {
    ssic_code: '2825',
    title:
      'Manufacture and Repair of Machinery for Food, Beverage and Tobacco Processing',
  },
  {
    ssic_code: '28251',
    title: 'Manufacture and Repair of Machinery for Food Products Processing',
  },
  {
    ssic_code: '28252',
    title: 'Manufacture and Repair of Machinery for Beverage Production',
  },
  {
    ssic_code: '28253',
    title: 'Manufacture and Repair of Machinery for Tobacco Processing',
  },
  {
    ssic_code: '28260',
    title:
      'Manufacture and Repair of Machinery for Textile, Apparel and Leather Production',
  },
  {
    ssic_code: '2827',
    title: 'Manufacture and Repair of Semiconductor Related Equipment',
  },
  {
    ssic_code: '28271',
    title: 'Manufacture of Probe Cards',
  },
  {
    ssic_code: '28272',
    title: 'Manufacture of Bonding Tools',
  },
  {
    ssic_code: '28273',
    title:
      'Manufacture and Repair of Semiconductor Assembly and Testing Equipment (including Computer Burn-In System)',
  },
  {
    ssic_code: '28274',
    title: 'Manufacture and Repair of Semiconductor Foundry Equipment',
  },
  {
    ssic_code: '2829',
    title: 'Manufacture and Repair of Other Special Purpose Machinery',
  },
  {
    ssic_code: '28291',
    title: 'Manufacture and Repair of Water/waste Water Treatment Equipment',
  },
  {
    ssic_code: '28292',
    title: 'Manufacture and Repair of Plastic Processing Machinery',
  },
  {
    ssic_code: '28293',
    title: 'Manufacture and Repair of Woodworking Machinery',
  },
  {
    ssic_code: '28294',
    title:
      'Manufacture and Repair of Polymer Additive Manufacturing (am) Equipment',
  },
  {
    ssic_code: '28299',
    title:
      'Manufacture and Repair of Other Special Purpose Machinery n.e.c. (including Plating Equipment, Industrial Paint Mixers and Chemical Mixing Equipment)',
  },
  {
    ssic_code: '2830',
    title: 'Installation of Industrial Machinery and Equipment',
  },
  {
    ssic_code: '28300',
    title:
      'Installation of Industrial Machinery and Equipment, Mechanical Engineering Works',
  },
  {
    ssic_code: '291',
    title: 'Manufacture of Motor Vehicles, Trailers and Semi-Trailers',
  },
  {
    ssic_code: '2910',
    title: 'Manufacture of Motor Vehicles',
  },
  {
    ssic_code: '29100',
    title: 'Manufacture and Assembly of Motor Vehicles',
  },
  {
    ssic_code: '29200',
    title:
      'Manufacture of Motor Vehicle Bodies (coachwork), Trailers and Semi-Trailers',
  },
  {
    ssic_code: '2930',
    title: 'Manufacture of Parts and Accessories for Motor Vehicles',
  },
  {
    ssic_code: '29300',
    title:
      'Manufacture of Parts and Accessories for Motor Vehicles (e.g. Engine Parts, Brakes, Clutches, Axles, Gear Boxes)',
  },
  {
    ssic_code: '3',
    title:
      'Fishing, Operation of Fish Hatcheries and Fish Farms; Service Activities Incidental to Fishing',
  },
  {
    ssic_code: '30',
    title: 'Manufacture of Other Transport Equipment',
  },
  {
    ssic_code: '301',
    title: 'Building and Repairing of Ships and Boats',
  },
  {
    ssic_code: '3011',
    title: 'Building and Repairing of Ships and Floating Structures',
  },
  {
    ssic_code: '30110',
    title:
      'Building and Repairing of Ships, Tankers and Other Ocean-Going Vessels (including Conversion of Ships Into Off-Shore Structures)',
  },
  {
    ssic_code: '3012',
    title: 'Building of Pleasure Boats and Sporting Boats',
  },
  {
    ssic_code: '30120',
    title: 'Building and Repair of Pleasure Crafts, Lighters and Boats',
  },
  {
    ssic_code: '3020',
    title: 'Manufacture of Railway Locomotives and Rolling Stock',
  },
  {
    ssic_code: '30200',
    title:
      'Manufacture and Repair of Railway and Tramway Locomotives and Rolling Stock (including Specialised Parts Except Engines, Electric Motors and Signalling Equipment)',
  },
  {
    ssic_code: '3030',
    title: 'Manufacture of Air and Spacecraft and Related Machinery',
  },
  {
    ssic_code: '30301',
    title:
      'Manufacture and Assembly of Aircraft and Spacecraft (including Aircraft Engines and Other Parts)',
  },
  {
    ssic_code: '30302',
    title:
      'Repair and Servicing of Aircraft and Spacecraft (including Aircraft Engines and Other Parts)',
  },
  {
    ssic_code: '30400',
    title: 'Manufacture of Military Fighting Vehicles',
  },
  {
    ssic_code: '3091',
    title: 'Manufacture of Motorcycles',
  },
  {
    ssic_code: '30910',
    title:
      'Manufacture and Assembly of Motorcycles and Scooters (including Engines and Other Parts and Accessories)',
  },
  {
    ssic_code: '3092',
    title: 'Manufacture of Bicycles and Invalid Carriages',
  },
  {
    ssic_code: '30920',
    title:
      'Manufacture and Assembly of Bicycles, Tricycles, Trishaws and Invalid Carriages (including Parts and Accessories)',
  },
  {
    ssic_code: '3099',
    title: 'Manufacture of Other Transport Equipment n.e.c.',
  },
  {
    ssic_code: '30990',
    title:
      'Manufacture of Other Transport Equipment n.e.c. (e.g. Carts, Wagons)',
  },
  {
    ssic_code: '310',
    title: 'Fishing',
  },
  {
    ssic_code: '3100',
    title: 'Manufacture of Furniture',
  },
  {
    ssic_code: '31001',
    title:
      'Manufacture of Furniture and Fixtures of Wood (including Upholstery)',
  },
  {
    ssic_code: '31002',
    title: 'Manufacture of Furniture of Rattan and Cane',
  },
  {
    ssic_code: '31003',
    title: 'Manufacture of Furniture and Fixtures Primarily of Metal',
  },
  {
    ssic_code: '31004',
    title:
      'Manufacture of Furniture of Other Materials Except Primarily of Stone, Ceramic or Concrete',
  },
  {
    ssic_code: '31005',
    title: 'Manufacture of Window and Door Screens and Shades',
  },
  {
    ssic_code: '31006',
    title: 'Manufacture of Mattresses Including Those of Foam Rubber',
  },
  {
    ssic_code: '31009',
    title: 'Manufacture of Furniture n.e.c.',
  },
  {
    ssic_code: '3101',
    title: 'Fishing in Kelongs',
  },
  {
    ssic_code: '3102',
    title: 'Ocean Fishing Except Fishing in Kelongs',
  },
  {
    ssic_code: '3103',
    title: 'Coastal Fishing Except Fishing in Kelongs',
  },
  {
    ssic_code: '3109',
    title: 'Fishing n.e.c.',
  },
  {
    ssic_code: '32',
    title: 'Operation of Fish Hatcheries and Fish Farms',
  },
  {
    ssic_code: '32',
    title: 'Other Manufacturing',
  },
  {
    ssic_code: '320',
    title: 'Fish Farming',
  },
  {
    ssic_code: '3201',
    title: 'Food Fish Farms',
  },
  {
    ssic_code: '3202',
    title: 'Ornamental Fish Farms',
  },
  {
    ssic_code: '3209',
    title:
      'Operation of Fish Hatcheries and Fish Farms n.e.c. (including Turtle, Prawn, Crab, Mussel Farms)',
  },
  {
    ssic_code: '321',
    title: 'Manufacture of Jewellery, Bijouterie and Related Articles',
  },
  {
    ssic_code: '3211',
    title: 'Manufacture of Jewellery and Related Articles',
  },
  {
    ssic_code: '32111',
    title: 'Manufacture of Jewellery Except Costume Jewellery',
  },
  {
    ssic_code: '32112',
    title: 'Manufacture of Pewter Ware',
  },
  {
    ssic_code: '32119',
    title:
      'Manufacture of Jewellery and Related Articles n.e.c. (except Costume Jewellery)',
  },
  {
    ssic_code: '32120',
    title: 'Manufacture of Costume Jewellery and Related Articles',
  },
  {
    ssic_code: '32200',
    title: 'Manufacture of Musical Instruments',
  },
  {
    ssic_code: '3230',
    title: 'Manufacture of Sports Goods',
  },
  {
    ssic_code: '32300',
    title:
      'Manufacture of Sporting and Athletic Goods (including Gym, Diving and Underwater Equipment)',
  },
  {
    ssic_code: '32400',
    title: 'Manufacture of Games and Toys',
  },
  {
    ssic_code: '3250',
    title: 'Manufacture of Medical and Dental Instruments and Supplies',
  },
  {
    ssic_code: '32501',
    title:
      'Manufacture of Medical Research and Clinical Diagnostic Instruments and Supplies (e.g. Reagents)',
  },
  {
    ssic_code: '32502',
    title:
      'Manufacture of Medical Disposables and Surgical Supplies (e.g. Test Kits, Syringes, Tubes, Fluid Administration Sets)',
  },
  {
    ssic_code: '32503',
    title:
      'Manufacture of Implantables and Artificial Limbs (e.g. Heart Valves, Stents, Orthopaedic Implants)',
  },
  {
    ssic_code: '32504',
    title:
      'Manufacture of Ophthalmic Goods (e.g. Spectacles, Contact Lenses and Parts)',
  },
  {
    ssic_code: '32509',
    title:
      'Manufacture of Medical and Dental Tools, Instruments and Supplies n.e.c.',
  },
  {
    ssic_code: '3290',
    title: 'Other Manufacturing n.e.c.',
  },
  {
    ssic_code: '32901',
    title:
      'Manufacture of Signs and Advertising Displays (including Neon-Lighting)',
  },
  {
    ssic_code: '32909',
    title: 'Other Manufacturing Industries n.e.c.',
  },
  {
    ssic_code: '35',
    title: 'Electricity, Gas, Steam and Air-Conditioning Supply',
  },
  {
    ssic_code: '3510',
    title: 'Electric Power Generation, Transmission and Distribution',
  },
  {
    ssic_code: '35101',
    title: 'Generation of Electricity By Fossil Fuels',
  },
  {
    ssic_code: '35102',
    title:
      'Generation of Electricity By Other Sources (e.g. Solar Power, Biofuels Etc)',
  },
  {
    ssic_code: '35103',
    title: 'Transmission, Distribution and Sale of Electricity',
  },
  {
    ssic_code: '35104',
    title: 'Other Related Services (e.g. Electricity Brokers, Meter Reading)',
  },
  {
    ssic_code: '35201',
    title: 'Manufacture of Gas; Distribution of Gaseous Fuels Through Mains',
  },
  {
    ssic_code: '35202',
    title: 'Processing of Natural Gas',
  },
  {
    ssic_code: '35203',
    title: 'Other Related Services (e.g. Arranging for Sale of Natural Gas)',
  },
  {
    ssic_code: '35300',
    title: 'Supply of Air or Water for Cooling or Heating Purposes',
  },
  {
    ssic_code: '3600',
    title: 'Water Collection, Treatment and Supply',
  },
  {
    ssic_code: '36000',
    title:
      'Collection, Purification and Distribution of Water (including Desalination of Water)',
  },
  {
    ssic_code: '3700',
    title: 'Sewerage',
  },
  {
    ssic_code: '37000',
    title: 'Operation of Sewer Systems (including Sewer Treatment Facilities)',
  },
  {
    ssic_code: '38',
    title:
      'Waste Collection, Treatment and Disposal Activities; Materials Recovery',
  },
  {
    ssic_code: '381',
    title: 'Waste Collection',
  },
  {
    ssic_code: '38100',
    title: 'Collection of Waste',
  },
  {
    ssic_code: '382',
    title: 'Waste Treatment and Disposal',
  },
  {
    ssic_code: '38200',
    title: 'Treatment and Disposal of Waste (including Remediation Activities)',
  },
  {
    ssic_code: '3830',
    title: 'Materials Recovery',
  },
  {
    ssic_code: '38301',
    title: 'Recycling of Metal Waste and Scrap',
  },
  {
    ssic_code: '38309',
    title:
      'Recycling of Non-Metal Waste n.e.c. (e.g. Marine Clay and Oil Sludge)',
  },
  {
    ssic_code: '4100',
    title: 'Construction of Buildings',
  },
  {
    ssic_code: '41001',
    title:
      'General Contractors (building Construction Including Major Upgrading Works)',
  },
  {
    ssic_code: '41002',
    title: 'Structural Repair Contractors',
  },
  {
    ssic_code: '41009',
    title: 'Building Construction n.e.c.',
  },
  {
    ssic_code: '42',
    title: 'Civil Engineering',
  },
  {
    ssic_code: '4210',
    title: 'Construction of Roads and Railways',
  },
  {
    ssic_code: '42101',
    title: 'General Contractors (non-Building Construction)',
  },
  {
    ssic_code: '42102',
    title: 'Road and Railway Construction',
  },
  {
    ssic_code: '42103',
    title: 'Bridge, Tunnel, Viaduct and Expressway Construction',
  },
  {
    ssic_code: '4220',
    title: 'Construction of Utility Projects',
  },
  {
    ssic_code: '42201',
    title: 'Water and Gas Pipe-Line and Sewer Construction',
  },
  {
    ssic_code: '42202',
    title: 'Communications and Power Line Construction',
  },
  {
    ssic_code: '4290',
    title: 'Construction of Other Civil Engineering Projects',
  },
  {
    ssic_code: '42901',
    title: 'Land Reclamation Works',
  },
  {
    ssic_code: '42902',
    title: 'Dam and Drainage Construction',
  },
  {
    ssic_code: '42903',
    title: 'Marine Construction (e.g. Harbours, Piers, Docks, Wharves)',
  },
  {
    ssic_code: '42909',
    title:
      'Construction of Other Civil Engineering Projects n.e.c. (e.g. Playground Systems)',
  },
  {
    ssic_code: '43',
    title: 'Specialised Construction Activities',
  },
  {
    ssic_code: '431',
    title: 'Demolition and Site Preparation',
  },
  {
    ssic_code: '4311',
    title: 'Demolition',
  },
  {
    ssic_code: '43110',
    title: 'Wrecking and Demolition Works',
  },
  {
    ssic_code: '4312',
    title: 'Site Preparation',
  },
  {
    ssic_code: '43121',
    title:
      'Soil Investigation, Treatment and Stabilisation (including Grouting and Guniting)',
  },
  {
    ssic_code: '43122',
    title: 'Excavation and Earthmoving Works',
  },
  {
    ssic_code: '43129',
    title: 'Site Preparation n.e.c.',
  },
  {
    ssic_code: '432',
    title: 'Electricity, Plumbing and Construction Installation Activities',
  },
  {
    ssic_code: '4321',
    title: 'Electrical Installation',
  },
  {
    ssic_code: '43210',
    title: 'Electrical Works',
  },
  {
    ssic_code: '4322',
    title: 'Plumbing, Heat and Air-Conditioning Installation',
  },
  {
    ssic_code: '43220',
    title:
      'Installation of Plumbing, Heating (non-Electric) and Air-Conditioning Systems',
  },
  {
    ssic_code: '4329',
    title: 'Other Construction Installation',
  },
  {
    ssic_code: '43291',
    title:
      'Installation and Erection of Building Equipment (e.g. Lifts, Escalators, Travellators)',
  },
  {
    ssic_code: '43292',
    title: 'Installation of Fire Protection and Security Alarm Systems',
  },
  {
    ssic_code: '43293',
    title: 'Installation of Building Automated Systems for Remote Monitoring',
  },
  {
    ssic_code: '43294',
    title: 'Installation of Awning and Window Shades',
  },
  {
    ssic_code: '43295',
    title:
      'Installation of Thermal and Sound Insulation (including Solar Control Films)',
  },
  {
    ssic_code: '43296',
    title: 'Signcraft Installation',
  },
  {
    ssic_code: '43299',
    title: 'Other Construction Installation n.e.c.',
  },
  {
    ssic_code: '4330',
    title: 'Building Completion and Finishing',
  },
  {
    ssic_code: '43301',
    title: 'Renovation Contractors',
  },
  {
    ssic_code: '43302',
    title: 'Tile Setting and Plastering',
  },
  {
    ssic_code: '43303',
    title: 'Joinery and Other Woodworks (e.g. Laminated or Parquet Flooring)',
  },
  {
    ssic_code: '43304',
    title: 'Painting and Decorating',
  },
  {
    ssic_code: '43305',
    title:
      'Glass and Glazing Works (including Mirror and Shower Screen Installation)',
  },
  {
    ssic_code: '43306',
    title: 'Curtain Walling/cladding Works',
  },
  {
    ssic_code: '43307',
    title: 'Installation of Doors, Gates, Grilles and Windows',
  },
  {
    ssic_code: '43309',
    title: 'Building Completion and Finishing n.e.c.',
  },
  {
    ssic_code: '4390',
    title: 'Other Specialised Construction Activities',
  },
  {
    ssic_code: '43901',
    title:
      'Foundation Works (including Micropiling, Conventional Piling and Underpinning)',
  },
  {
    ssic_code: '43902',
    title: 'Brick Laying, Stone Setting and Cement Works',
  },
  {
    ssic_code: '43903',
    title: 'Roofing Works (including Timber Carcassing)',
  },
  {
    ssic_code: '43904',
    title: 'Production of Pre-Cast Components',
  },
  {
    ssic_code: '43905',
    title: 'Scaffolding Works',
  },
  {
    ssic_code: '43906',
    title: 'Sandblasting/shotblasting Works (except Ships)',
  },
  {
    ssic_code: '43907',
    title:
      'Production of Prefabricated Prefinished Volumetric Construction (ppvc) Modules',
  },
  {
    ssic_code: '43909',
    title:
      'Other Specialised Construction and Related Activities n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '46',
    title: 'Wholesale Trade',
  },
  {
    ssic_code: '4610',
    title: 'Wholesale on A Fee or Commission Basis',
  },
  {
    ssic_code: '46100',
    title:
      'Wholesale on A Fee or Commission Basis (excluding Online Marketplaces)',
  },
  {
    ssic_code: '462',
    title: 'Wholesale of Agricultural Raw Materials and Live Animals',
  },
  {
    ssic_code: '4621',
    title:
      'Wholesale of Agricultural Raw Materials and Live Animals Except Tropical Produce',
  },
  {
    ssic_code: '46211',
    title: 'Wholesale of Cut Flowers and Plants',
  },
  {
    ssic_code: '46212',
    title: 'Wholesale of Aquarium Fishes (including Food and Accessories)',
  },
  {
    ssic_code: '46213',
    title:
      'Wholesale of Pet Birds and Animals (including Food and Accessories)',
  },
  {
    ssic_code: '46219',
    title:
      'Wholesale of Agricultural Raw Materials and Live Animals n.e.c. (excluding Tropical Produce)',
  },
  {
    ssic_code: '4622',
    title: 'Wholesale of Tropical Produce',
  },
  {
    ssic_code: '46221',
    title: 'Wholesale of Rubber (including Rubber Brokers)',
  },
  {
    ssic_code: '46222',
    title: 'Wholesale of Pepper and Other Spices',
  },
  {
    ssic_code: '46223',
    title: 'Wholesale of Coffee, Cocoa and Tea',
  },
  {
    ssic_code: '46224',
    title: 'Wholesale of Coconut',
  },
  {
    ssic_code: '46225',
    title: 'Wholesale of Palm Oil',
  },
  {
    ssic_code: '46229',
    title: 'Wholesale of Tropical Produce n.e.c.',
  },
  {
    ssic_code: '4630',
    title: 'Wholesale of Food, Beverages and Tobacco',
  },
  {
    ssic_code: '46301',
    title: 'Wholesale of Fruits and Vegetables (including Fresh and Frozen)',
  },
  {
    ssic_code: '46302',
    title:
      'Wholesale of Livestock, Meat, Poultry, Eggs and Seafood (including Fresh and Frozen)',
  },
  {
    ssic_code: '46303',
    title:
      'Wholesale of A General Line (wide Range) of Groceries (e.g. Cereals, Sugar, Edible Oils, Sauces and Dairy Products)',
  },
  {
    ssic_code: '46304',
    title: 'Wholesale of Confectionery and Bakery Products',
  },
  {
    ssic_code: '46305',
    title: 'Wholesale of Ice-Cream',
  },
  {
    ssic_code: '46306',
    title: 'Wholesale of Health Supplements',
  },
  {
    ssic_code: '46307',
    title: 'Wholesale of Liquor, Soft Drinks and Beverages',
  },
  {
    ssic_code: '46308',
    title: 'Wholesale of Tobacco Products',
  },
  {
    ssic_code: '46309',
    title:
      'Wholesale of Food, Beverages and Tobacco n.e.c. (including Dried or Canned)',
  },
  {
    ssic_code: '464',
    title: 'Wholesale of Household Goods',
  },
  {
    ssic_code: '4641',
    title: 'Wholesale of Textiles, Clothing, Footwear and Leather Goods',
  },
  {
    ssic_code: '46411',
    title: 'Wholesale of Textiles and Leathers',
  },
  {
    ssic_code: '46412',
    title: "Wholesale of Adults' Clothing",
  },
  {
    ssic_code: '46413',
    title:
      'Wholesale of Children and Infants’ Clothing (including Products and Accessories for Infants)',
  },
  {
    ssic_code: '46414',
    title: 'Wholesale of Footwear',
  },
  {
    ssic_code: '46415',
    title: 'Wholesale of Bags, Luggage and Travel Accessories',
  },
  {
    ssic_code: '46416',
    title:
      'Wholesale of Sewing and Clothing Accessories (e.g. Button, Thread, Lace, Zip, Belt, Tie)',
  },
  {
    ssic_code: '4642',
    title: 'Wholesale of Personal Effects',
  },
  {
    ssic_code: '46421',
    title: 'Wholesale of Jewellery Made From Precious Metals and Stones',
  },
  {
    ssic_code: '46422',
    title: 'Wholesale of Costume Jewellery',
  },
  {
    ssic_code: '46423',
    title: 'Wholesale of Watches and Clocks',
  },
  {
    ssic_code: '46424',
    title: 'Wholesale of Cosmetics and Toiletries',
  },
  {
    ssic_code: '46429',
    title: 'Wholesale of Personal Effects n.e.c.',
  },
  {
    ssic_code: '4643',
    title:
      'Wholesale of Furniture, Home Furnishings and Other Household Equipment',
  },
  {
    ssic_code: '46431',
    title: 'Wholesale of Furniture (including Mattresses, Cushions)',
  },
  {
    ssic_code: '46432',
    title: 'Wholesale of Furnishings (including Curtains, Carpets, Wallpaper)',
  },
  {
    ssic_code: '46433',
    title: 'Wholesale of Lighting and Lighting Accessories',
  },
  {
    ssic_code: '46434',
    title: 'Wholesale of Crockery, Cutlery and Kitchen Utensils',
  },
  {
    ssic_code: '46435',
    title:
      'Wholesale of Household Electrical Appliances and Equipment (including Household Air-Conditioners)',
  },
  {
    ssic_code: '46436',
    title:
      'Wholesale of Audio and Video Equipment Except Electrical and Electronic Components (e.g. Radio and Television Sets, Sound Reproducing and Recording Equipment)',
  },
  {
    ssic_code: '46437',
    title: 'Wholesale of Musical Instruments and Scores',
  },
  {
    ssic_code: '46439',
    title:
      'Wholesale of Furniture, Home Furnishings and Other Household Equipment n.e.c.',
  },
  {
    ssic_code: '4644',
    title: 'Wholesale of Sporting and Other Recreational Goods',
  },
  {
    ssic_code: '46441',
    title:
      'Wholesale of Sporting Goods and Equipment (including Bicycles and Healthcare Equipment)',
  },
  {
    ssic_code: '46442',
    title: 'Wholesale of Music and Video Recordings (e.g. Dvds, Blu-Ray Discs)',
  },
  {
    ssic_code: '46443',
    title: 'Wholesale of Toys and Games',
  },
  {
    ssic_code: '46444',
    title:
      'Wholesale of Computer Games (including Electronic Games and Video Game Consoles)',
  },
  {
    ssic_code: '46449',
    title: 'Wholesale of Sporting and Other Recreational Goods n.e.c.',
  },
  {
    ssic_code: '4645',
    title: 'Wholesale of Handicrafts and Fancy Goods',
  },
  {
    ssic_code: '46451',
    title: 'Wholesale of Antiques and Works of Art',
  },
  {
    ssic_code: '46452',
    title: 'Wholesale of Handicrafts and Gifts',
  },
  {
    ssic_code: '46453',
    title: 'Wholesale of Artificial Flowers and Plants',
  },
  {
    ssic_code: '46459',
    title: 'Wholesale of Handicrafts and Fancy Goods n.e.c.',
  },
  {
    ssic_code: '4646',
    title: 'Wholesale of Medicinal and Pharmaceutical Products',
  },
  {
    ssic_code: '46461',
    title: 'Wholesale of Medicinal and Pharmaceutical Products (western)',
  },
  {
    ssic_code: '46462',
    title: 'Wholesale of Medicine and Herbs (other Than Western)',
  },
  {
    ssic_code: '4647',
    title:
      'Wholesale of Paper, Paper-Related Products, Stationery, Cellophane Products and Packaging Materials',
  },
  {
    ssic_code: '46471',
    title: 'Wholesale of Paper and Paper Products',
  },
  {
    ssic_code: '46472',
    title: 'Wholesale of Packaging Materials',
  },
  {
    ssic_code: '46473',
    title: 'Wholesale of Stationery',
  },
  {
    ssic_code: '46474',
    title: 'Wholesale of Books and Magazines',
  },
  {
    ssic_code: '46479',
    title:
      'Wholesale of Paper, Paper and Cellophane Products and Stationery n.e.c.',
  },
  {
    ssic_code: '4649',
    title: 'Wholesale of Other Household Goods',
  },
  {
    ssic_code: '46491',
    title: 'Wholesale of Optical Equipment and Supplies (excluding Binoculars)',
  },
  {
    ssic_code: '46492',
    title:
      'Wholesale of Photographic Equipment and Supplies (including Binoculars)',
  },
  {
    ssic_code: '46499',
    title: 'Wholesale of Other Household Goods n.e.c.',
  },
  {
    ssic_code: '465',
    title: 'Wholesale of Machinery, Equipment and Supplies',
  },
  {
    ssic_code: '4651',
    title: 'Wholesale of Computers, Computer Peripheral Equipment and Software',
  },
  {
    ssic_code: '46511',
    title:
      'Wholesale of Computer Hardware and Peripheral Equipment (except Cybersecurity Related Hardware and Peripheral Equipment)',
  },
  {
    ssic_code: '46512',
    title:
      'Wholesale of Computer Software (except Games and Cybersecurity Software)',
  },
  {
    ssic_code: '46513',
    title:
      'Wholesale of Computer Accessories (e.g. Memory Cards, Computer Cables)',
  },
  {
    ssic_code: '46514',
    title:
      'Wholesale of Cybersecurity Software, Hardware and Peripheral Equipment',
  },
  {
    ssic_code: '4652',
    title: 'Wholesale of Electronic and Telecommunications Equipment and Parts',
  },
  {
    ssic_code: '46521',
    title: 'Wholesale of Telecommunications Equipment (excluding Handphones)',
  },
  {
    ssic_code: '46522',
    title: 'Wholesale of Electronic Components',
  },
  {
    ssic_code: '46523',
    title:
      'Wholesale of Handphones, Handphone Peripheral Equipment and Other Telecommunications Equipment',
  },
  {
    ssic_code: '46530',
    title: 'Wholesale of Agricultural Machinery, Equipment and Supplies',
  },
  {
    ssic_code: '4654',
    title:
      'Wholesale of Industrial, Construction and Related Machinery and Equipment',
  },
  {
    ssic_code: '46541',
    title:
      'Wholesale of Industrial Machinery and Equipment (e.g. Industrial Crane)',
  },
  {
    ssic_code: '46542',
    title: 'Wholesale of Construction Equipment (e.g. Concrete Mixer)',
  },
  {
    ssic_code: '46543',
    title:
      'Wholesale of Lifts, Escalators and Industrial and Office Air-Conditioning Equipment',
  },
  {
    ssic_code: '46544',
    title: 'Wholesale of Electrical and Wiring Accessories',
  },
  {
    ssic_code: '46549',
    title:
      'Wholesale of Industrial, Construction and Related Machinery and Equipment n.e.c.',
  },
  {
    ssic_code: '4655',
    title:
      'Wholesale of Transport Equipment Except Motor Vehicles and Motorcycles',
  },
  {
    ssic_code: '46551',
    title:
      'Wholesale of Marine Equipment and Accessories (including Marine Navigational Equipment and Radar)',
  },
  {
    ssic_code: '46552',
    title:
      'Wholesale of Aircraft Equipment and Supplies (including Aeronautical Equipment)',
  },
  {
    ssic_code: '46559',
    title:
      'Wholesale of Transport Equipment Except Motor Vehicles and Motorcycles n.e.c.',
  },
  {
    ssic_code: '4656',
    title: 'Wholesale of Motor Vehicles, Parts and Accessories',
  },
  {
    ssic_code: '46561',
    title: 'Wholesale of Motor Vehicles Except Motorcycles and Scooters',
  },
  {
    ssic_code: '46562',
    title: 'Wholesale of Motorcycles and Scooters',
  },
  {
    ssic_code: '46563',
    title: 'Wholesale of Parts and Accessories for Vehicles',
  },
  {
    ssic_code: '4659',
    title: 'Wholesale of Other Machinery and Equipment',
  },
  {
    ssic_code: '46591',
    title: 'Wholesale of Office Machines and Equipment (including Accessories)',
  },
  {
    ssic_code: '46592',
    title:
      'Wholesale of Medical, Professional, Scientific and Precision Equipment',
  },
  {
    ssic_code: '46593',
    title:
      'Wholesale of Commercial Food Service Equipment (e.g. Hotel Kitchen Equipment)',
  },
  {
    ssic_code: '46594',
    title:
      'Wholesale of Service Establishment Equipment and Supplies (e.g. Beauty Salon Equipment)',
  },
  {
    ssic_code: '46595',
    title: 'Wholesale of Security and Safety Equipment',
  },
  {
    ssic_code: '46599',
    title: 'Wholesale of Other Machinery and Equipment n.e.c.',
  },
  {
    ssic_code: '466',
    title: 'Other Specialised Wholesale',
  },
  {
    ssic_code: '46610',
    title: 'Wholesale of Fuels and Related Products',
  },
  {
    ssic_code: '4662',
    title: 'Wholesale of Metals and Metal Ores',
  },
  {
    ssic_code: '46620',
    title:
      'Wholesale of Metals and Metal Ores (e.g. Steel Pipes) Except General Hardware',
  },
  {
    ssic_code: '4663',
    title:
      'Wholesale of Construction Materials, Hardware, Plumbing and Heating Equipment and Supplies',
  },
  {
    ssic_code: '46631',
    title: 'Wholesale of Logs, Sawn Timber, Plywood and Related Products',
  },
  {
    ssic_code: '46632',
    title: 'Wholesale of General Hardware (e.g. Locks, Hinges)',
  },
  {
    ssic_code: '46633',
    title:
      'Wholesale of Structural Clay and Concrete Products (e.g. Mosaic Tiles, Bricks)',
  },
  {
    ssic_code: '46634',
    title: 'Wholesale of Paints (including Varnishes and Supplies)',
  },
  {
    ssic_code: '46635',
    title: 'Wholesale of Glass',
  },
  {
    ssic_code: '46639',
    title:
      'Wholesale of Construction Materials, Hardware, Plumbing and Heating Equipment and Supplies n.e.c. (e.g. Cement, Sand)',
  },
  {
    ssic_code: '4664',
    title: 'Wholesale of Chemicals and Chemical Products',
  },
  {
    ssic_code: '46641',
    title: 'Wholesale of Basic Industrial Chemicals (except Fertilisers)',
  },
  {
    ssic_code: '46642',
    title: 'Wholesale of Chemical Fertilisers',
  },
  {
    ssic_code: '46643',
    title: 'Wholesale of Petrochemical Products',
  },
  {
    ssic_code: '46649',
    title: 'Wholesale of Chemicals and Chemical Products n.e.c.',
  },
  {
    ssic_code: '4665',
    title: 'Wholesale of Other Intermediate Products, Waste and Scrap',
  },
  {
    ssic_code: '46651',
    title: 'Wholesale of Scrap, Junk and Waste Dealers',
  },
  {
    ssic_code: '46659',
    title: 'Wholesale of Other Intermediate Products, Waste and Scrap n.e.c.',
  },
  {
    ssic_code: '4666',
    title: 'Ship Chandlers and Ship Bunkering',
  },
  {
    ssic_code: '46661',
    title: 'Ship Chandlers',
  },
  {
    ssic_code: '46662',
    title: 'Ship Bunkering',
  },
  {
    ssic_code: '4690',
    title: 'Non-Specialised Wholesale Trade',
  },
  {
    ssic_code: '46900',
    title: 'Wholesale Trade of A Variety of Goods Without A Dominant Product',
  },
  {
    ssic_code: '47',
    title: 'Retail Trade',
  },
  {
    ssic_code: '4710',
    title: 'Retail Sale in Non-Specialised Stores',
  },
  {
    ssic_code: '47101',
    title: 'Supermarkets and Hypermarkets',
  },
  {
    ssic_code: '47102',
    title: 'Mini-Marts, Convenience Stores and Provision Shops',
  },
  {
    ssic_code: '47103',
    title: 'Department Stores',
  },
  {
    ssic_code: '47109',
    title: 'Retail Sale in Other Non-Specialised Stores n.e.c.',
  },
  {
    ssic_code: '472',
    title: 'Retail Sale of Food, Beverages and Tobacco in Specialised Stores',
  },
  {
    ssic_code: '4721',
    title: 'Retail Sale of Food in Specialised Stores',
  },
  {
    ssic_code: '47211',
    title: 'Retail Sale of Fruits and Vegetables',
  },
  {
    ssic_code: '47212',
    title: 'Retail Sale of Meat, Poultry, Eggs and Seafood',
  },
  {
    ssic_code: '47213',
    title:
      'Retail Sale of Confectionery and Bakery Products (not Manufactured on Site)',
  },
  {
    ssic_code: '47214',
    title: 'Retail Sale of Health Supplements',
  },
  {
    ssic_code: '47219',
    title: 'Retail Sale of Food n.e.c.',
  },
  {
    ssic_code: '4722',
    title: 'Retail Sale of Beverages in Specialised Stores',
  },
  {
    ssic_code: '47220',
    title: 'Retail Sale of Beverages',
  },
  {
    ssic_code: '4723',
    title: 'Retail Sale of Tobacco Products in Specialised Stores',
  },
  {
    ssic_code: '47230',
    title: 'Retail Sale of Tobacco Products',
  },
  {
    ssic_code: '473',
    title:
      'Retail Sale of Motor Vehicles, Parts, Accessories and Automotive Fuel in Specialised Stores',
  },
  {
    ssic_code: '4731',
    title:
      'Retail Sale of Motor Vehicles, Parts and Accessories in Specialised Stores',
  },
  {
    ssic_code: '47311',
    title: 'Retail Sale of Motor Vehicles Except Motorcycles and Scooters',
  },
  {
    ssic_code: '47312',
    title: 'Retail Sale of Motorcycles and Scooters',
  },
  {
    ssic_code: '47313',
    title: 'Retail Sale of Tyres and Batteries',
  },
  {
    ssic_code: '47314',
    title: 'Retail Sale of Spare Parts and Accessories for Motor Vehicles',
  },
  {
    ssic_code: '4732',
    title: 'Retail Sale of Automotive Fuel in Specialised Stores',
  },
  {
    ssic_code: '47320',
    title:
      'Retail Sale of Automotive Fuel (e.g. Petrol Kiosks, Cng Refilling Stations)',
  },
  {
    ssic_code: '474',
    title:
      'Retail Sale of Information and Communications Equipment in Specialised Stores',
  },
  {
    ssic_code: '4741',
    title:
      'Retail Sale of Computers, Peripheral Equipment, Software and Telecommunications Equipment in Specialised Stores',
  },
  {
    ssic_code: '47411',
    title: 'Retail Sale of Handphones and Peripheral Equipment',
  },
  {
    ssic_code: '47412',
    title:
      'Retail Sale of Computer Hardware (including Handheld Computers) and Peripheral Equipment, and Computer Software (except Games and Cybersecurity Hardware and Software)',
  },
  {
    ssic_code: '47413',
    title:
      'Retail Sale of Computer Games (including Electronic Games and Video Game Consoles)',
  },
  {
    ssic_code: '47414',
    title:
      'Retail Sale of Computer and Office Equipment Consumables (e.g. Printer Cartridges)',
  },
  {
    ssic_code: '47415',
    title:
      'Retail Sale of Cybersecurity Software, Hardware and Peripheral Equipment',
  },
  {
    ssic_code: '4742',
    title: 'Retail Sale of Audio and Video Equipment in Specialised Stores',
  },
  {
    ssic_code: '47420',
    title:
      'Retail Sale of Audio and Video Equipment (e.g. Radio and Television Sets, Sound Reproducing and Recording Equipment)',
  },
  {
    ssic_code: '475',
    title: 'Retail Sale of Other Household Equipment in Specialised Stores',
  },
  {
    ssic_code: '4751',
    title: 'Retail Sale of Textiles in Specialised Stores',
  },
  {
    ssic_code: '47510',
    title: 'Retail Sale of Textiles',
  },
  {
    ssic_code: '4752',
    title: 'Retail Sale of Hardware, Paint and Glass in Specialised Stores',
  },
  {
    ssic_code: '47521',
    title: 'Retail Sale of Paints',
  },
  {
    ssic_code: '47522',
    title: 'Retail Sale of Hardware (e.g. Chains, Changkols, Axes)',
  },
  {
    ssic_code: '47529',
    title:
      'Retail Sale of Hardware, Paint and Glass n.e.c. (e.g. Wood, Glass, Sanitary Ware, Do-It-Yourself Materials)',
  },
  {
    ssic_code: '4753',
    title:
      'Retail Sale of Electrical Household Appliances, Furniture, Lighting Equipment and Other Household Articles in Specialised Stores',
  },
  {
    ssic_code: '47531',
    title: 'Retail Sale of Furniture (including Mattresses, Cushions)',
  },
  {
    ssic_code: '47532',
    title: 'Retail Sale of Furnishings (e.g. Curtains, Carpets, Pillow Cases)',
  },
  {
    ssic_code: '47533',
    title: 'Retail Sale of Lighting and Lighting Accessories',
  },
  {
    ssic_code: '47534',
    title: 'Retail Sale of Crockery, Cutlery and Kitchen Utensils',
  },
  {
    ssic_code: '47535',
    title:
      'Retail Sale of Household Electrical Appliances and Equipment (e.g. Vacuum Cleaners, Washing Machines, Refrigerators)',
  },
  {
    ssic_code: '47536',
    title: 'Retail Sale of Musical Instruments and Scores',
  },
  {
    ssic_code: '47537',
    title: 'Retail Sale of Security and Safety Equipment',
  },
  {
    ssic_code: '47539',
    title:
      'Retail Sale of Electrical Household Appliances, Furniture, Lighting Equipment and Other Household Articles n.e.c.',
  },
  {
    ssic_code: '476',
    title: 'Retail Sale of Cultural and Recreation Goods in Specialised Stores',
  },
  {
    ssic_code: '4761',
    title:
      'Retail Sale of Books, Newspapers and Stationery in Specialised Stores',
  },
  {
    ssic_code: '47610',
    title:
      'Retail Sale of Books, Newspapers and Stationery (including Newsvendors)',
  },
  {
    ssic_code: '4762',
    title: 'Retail Sale of Music and Video Recordings in Specialised Stores',
  },
  {
    ssic_code: '47620',
    title:
      'Retail Sale of Music and Video Recordings (e.g. Dvds, Blu-Ray Discs)',
  },
  {
    ssic_code: '4763',
    title: 'Retail Sale of Sporting Equipment in Specialised Stores',
  },
  {
    ssic_code: '47630',
    title:
      'Retail Sale of Sports Apparel and Equipment (including Bicycles, Boats and Healthcare Equipment)',
  },
  {
    ssic_code: '4764',
    title: 'Retail Sale of Games and Toys in Specialised Stores',
  },
  {
    ssic_code: '47640',
    title: 'Retail Sale of Games and Toys',
  },
  {
    ssic_code: '4771',
    title:
      'Retail Sale of Clothing, Footwear and Leather Articles in Specialised Stores',
  },
  {
    ssic_code: '47711',
    title: 'Retail Sale of Clothing for Adults',
  },
  {
    ssic_code: '47712',
    title:
      'Retail Sale of Children and Infants’ Clothing (including Products and Accessories for Infants)',
  },
  {
    ssic_code: '47713',
    title: 'Retail Sale of Footwear',
  },
  {
    ssic_code: '47714',
    title: 'Retail Sale of Bags, Luggage and Travel Accessories',
  },
  {
    ssic_code: '47715',
    title:
      'Retail Sale of Sewing and Clothing Accessories (e.g. Button, Thread, Lace, Zip, Belt, Tie)',
  },
  {
    ssic_code: '47719',
    title: 'Retail Sale of Clothing, Footwear and Leather Articles n.e.c.',
  },
  {
    ssic_code: '4772',
    title:
      'Retail Sale of Pharmaceutical and Medical Goods, Cosmetics and Toilet Articles in Specialised Stores',
  },
  {
    ssic_code: '47721',
    title:
      'Retail Sale of Cosmetics and Toiletries (including Skin Care Products)',
  },
  {
    ssic_code: '47722',
    title: 'Pharmacies and Drug Stores (western)',
  },
  {
    ssic_code: '47723',
    title: 'Chinese Medicine Shops',
  },
  {
    ssic_code: '47729',
    title: 'Retail Sale of Pharmaceutical and Medical Goods n.e.c.',
  },
  {
    ssic_code: '4773',
    title: 'Retail Sale of Personal Effects in Specialised Stores',
  },
  {
    ssic_code: '47731',
    title: 'Retail Sale of Jewellery Made From Precious Metals and Stones',
  },
  {
    ssic_code: '47732',
    title: 'Retail Sale of Costume Jewellery',
  },
  {
    ssic_code: '47733',
    title: 'Retail Sale of Watches and Clocks',
  },
  {
    ssic_code: '47739',
    title: 'Retail Sale of Personal Effects n.e.c.',
  },
  {
    ssic_code: '4774',
    title:
      'Retail Sale of Handicrafts and Fancy Goods, Flowers, Plants and Pet Animals in Specialised Stores',
  },
  {
    ssic_code: '47741',
    title: 'Retail Sale of Antiques and Works of Art',
  },
  {
    ssic_code: '47742',
    title: 'Retail Sale of Handicrafts, Collectibles and Gifts',
  },
  {
    ssic_code: '47743',
    title: 'Retail Sale of Cut Flowers (including Wreaths)',
  },
  {
    ssic_code: '47744',
    title: 'Retail Sale of Artificial Flowers and Plants',
  },
  {
    ssic_code: '47745',
    title: 'Retail Sale of Aquarium Fishes (including Food and Accessories)',
  },
  {
    ssic_code: '47746',
    title:
      'Retail Sale of Pet Birds and Animals (including Food and Accessories)',
  },
  {
    ssic_code: '47749',
    title:
      'Retail Sale of Handicrafts and Fancy Goods, Flowers, Plants and Pet Animals n.e.c.',
  },
  {
    ssic_code: '4775',
    title:
      'Retail Sale of Optical and Photographic Goods in Specialised Stores',
  },
  {
    ssic_code: '47751',
    title: 'Retail Sale of Spectacles and Other Optical Goods',
  },
  {
    ssic_code: '47752',
    title: 'Retail Sale of Cameras and Other Photographic Goods',
  },
  {
    ssic_code: '47759',
    title: 'Retail Sale of Optical and Photographic Goods n.e.c.',
  },
  {
    ssic_code: '4776',
    title: 'Retail Sale of Other Goods in Specialised Stores',
  },
  {
    ssic_code: '47761',
    title: 'Retail Sale of Joss Paper and Other Ceremonial Products',
  },
  {
    ssic_code: '47762',
    title: 'Retail Sale of Liquefied Petroleum Gas (lpg)',
  },
  {
    ssic_code: '47769',
    title: 'Retail Sale of Specific Commodities n.e.c.',
  },
  {
    ssic_code: '47770',
    title: 'Retail Sale of Second-Hand Goods in Stores',
  },
  {
    ssic_code: '478',
    title: 'Retail Sale Via Stalls and Markets',
  },
  {
    ssic_code: '4780',
    title:
      'Retail Sale Via Stalls and Markets of Uncooked Food and Other Commodities',
  },
  {
    ssic_code: '47801',
    title: 'Stalls (including Pushcarts) Selling Uncooked Food',
  },
  {
    ssic_code: '47802',
    title:
      'Stalls (including Pushcarts) Selling Other Commodities (other Than Uncooked Food)',
  },
  {
    ssic_code: '49',
    title: 'Land Transport and Transport Via Pipelines',
  },
  {
    ssic_code: '491',
    title: 'Transport Via Railways',
  },
  {
    ssic_code: '4910',
    title: 'Passenger and Freight Rail Transport',
  },
  {
    ssic_code: '49101',
    title: 'Railroad Services',
  },
  {
    ssic_code: '49102',
    title: 'Mass Rapid Transit Systems (including Light Rail)',
  },
  {
    ssic_code: '492',
    title: 'Other Land Transport',
  },
  {
    ssic_code: '4921',
    title: 'Passenger Land Transport',
  },
  {
    ssic_code: '49211',
    title: 'Public Bus Services (scheduled Services)',
  },
  {
    ssic_code: '49212',
    title: 'Chartered Bus Services (including School Buses)',
  },
  {
    ssic_code: '49213',
    title: 'Inter-Country Bus Services',
  },
  {
    ssic_code: '49214',
    title: 'Street-Hail and Ride-Hail Service Providers',
  },
  {
    ssic_code: '49215',
    title:
      'Rental and Leasing of Cars with Driver (excluding Street-Hail and Ride-Hail Service Providers)',
  },
  {
    ssic_code: '4922',
    title: 'Aerial Cableways',
  },
  {
    ssic_code: '49220',
    title: 'Aerial Cableways (including Cable Car Services)',
  },
  {
    ssic_code: '4923',
    title: 'Freight Land Transport',
  },
  {
    ssic_code: '49231',
    title: 'Freight Transport By Road',
  },
  {
    ssic_code: '49232',
    title: 'Moving Services',
  },
  {
    ssic_code: '49233',
    title:
      'Rental and Leasing of Freight Land Transport Vehicle (e.g. Lorries and Trucks) with Driver',
  },
  {
    ssic_code: '49300',
    title: 'Transport Via Pipelines',
  },
  {
    ssic_code: '500',
    title: 'Water Transport',
  },
  {
    ssic_code: '5001',
    title: 'Passenger Water Transport',
  },
  {
    ssic_code: '50011',
    title: 'International Cruise Services',
  },
  {
    ssic_code: '50012',
    title:
      'Other Sight-Seeing Cruise Services (e.g. Harbour and River Cruises)',
  },
  {
    ssic_code: '50013',
    title: 'Passenger Ferry Services',
  },
  {
    ssic_code: '50014',
    title: 'Chartering of Ships and Boats with Crew (passenger)',
  },
  {
    ssic_code: '5002',
    title: 'Freight Water Transport',
  },
  {
    ssic_code: '50021',
    title:
      'Shipping Companies, Including Chartering of Ships and Boats with Crew (freight)',
  },
  {
    ssic_code: '50022',
    title:
      'Operators and Charterers of Barges, Tugboats and Bumboats (freight)',
  },
  {
    ssic_code: '50023',
    title: 'Branches of Foreign Shipping Lines',
  },
  {
    ssic_code: '5100',
    title: 'Air Transport',
  },
  {
    ssic_code: '51001',
    title: 'Airlines (passenger)',
  },
  {
    ssic_code: '51002',
    title: 'Airlines (freight)',
  },
  {
    ssic_code: '51003',
    title: 'Branches of Foreign Airlines (passenger)',
  },
  {
    ssic_code: '51004',
    title: 'Branches of Foreign Airlines (freight)',
  },
  {
    ssic_code: '51005',
    title: 'Aircraft Chartering with Operator',
  },
  {
    ssic_code: '52',
    title: 'Warehousing and Support Activities for Transportation',
  },
  {
    ssic_code: '5210',
    title: 'Warehousing and Storage',
  },
  {
    ssic_code: '52101',
    title: 'General Warehousing',
  },
  {
    ssic_code: '52102',
    title: 'Refrigerated Warehousing and Storage',
  },
  {
    ssic_code: '52103',
    title: 'Storage for Dangerous Goods',
  },
  {
    ssic_code: '52109',
    title:
      'Specialised Storage n.e.c. (e.g. Wine Warehousing, Document Storage and Warehousing)',
  },
  {
    ssic_code: '522',
    title: 'Support Activities for Transportation',
  },
  {
    ssic_code: '5221',
    title: 'Supporting Services to Land Transport',
  },
  {
    ssic_code: '52211',
    title: 'Carpark Management and Operation Services',
  },
  {
    ssic_code: '52212',
    title: 'Motor Vehicle Towing Services',
  },
  {
    ssic_code: '52219',
    title: 'Supporting Services to Land Transport n.e.c.',
  },
  {
    ssic_code: '5222',
    title: 'Supporting Services to Water Transport',
  },
  {
    ssic_code: '52221',
    title: 'Representative Offices of Foreign Shipping Lines',
  },
  {
    ssic_code: '52222',
    title: 'Shipping Agencies (freight)',
  },
  {
    ssic_code: '52223',
    title: 'Port Operators',
  },
  {
    ssic_code: '52224',
    title: 'Lighterage Services',
  },
  {
    ssic_code: '52225',
    title: 'Salvaging of Distressed Vessels and Cargos',
  },
  {
    ssic_code: '52226',
    title: 'Ship Management Services',
  },
  {
    ssic_code: '52227',
    title: 'Ship Brokering Services',
  },
  {
    ssic_code: '52229',
    title: 'Supporting Services to Water Transport n.e.c.',
  },
  {
    ssic_code: '5223',
    title: 'Supporting Services to Air Transport',
  },
  {
    ssic_code: '52231',
    title: 'Representative Offices of Foreign Airlines',
  },
  {
    ssic_code: '52232',
    title: 'Airline Agencies (freight)',
  },
  {
    ssic_code: '52233',
    title: 'Airport Operation Services',
  },
  {
    ssic_code: '52234',
    title: 'Airport Terminal Services (e.g. Ground Service Activities)',
  },
  {
    ssic_code: '52239',
    title: 'Supporting Services to Air Transport n.e.c.',
  },
  {
    ssic_code: '5224',
    title: 'Cargo Handling',
  },
  {
    ssic_code: '52241',
    title: 'Container Depot Services',
  },
  {
    ssic_code: '52242',
    title: 'Crane Services for All Industries Except Construction',
  },
  {
    ssic_code: '52243',
    title: 'Stevedoring Services',
  },
  {
    ssic_code: '5225',
    title: 'Marine Surveying Services and Classification Societies',
  },
  {
    ssic_code: '52251',
    title: 'Classification Societies',
  },
  {
    ssic_code: '52252',
    title: 'Marine Surveying Services Other Than Classification Societies',
  },
  {
    ssic_code: '5229',
    title: 'Other Transportation Support Activities',
  },
  {
    ssic_code: '52291',
    title: 'Cargo Surveying Services',
  },
  {
    ssic_code: '52292',
    title: 'Freight Transport Arrangement',
  },
  {
    ssic_code: '53',
    title: 'Postal and Courier Activities',
  },
  {
    ssic_code: '531',
    title: 'Postal Activities',
  },
  {
    ssic_code: '5310',
    title: 'National Post Activities',
  },
  {
    ssic_code: '53100',
    title: 'National Post Activities (e.g. Postal Services)',
  },
  {
    ssic_code: '532',
    title: 'Courier Activities',
  },
  {
    ssic_code: '53200',
    title: 'Courier Activities Other Than National Post Activities',
  },
  {
    ssic_code: '55',
    title: 'Accommodation',
  },
  {
    ssic_code: '5510',
    title: 'Short Term Accommodation Activities',
  },
  {
    ssic_code: '55101',
    title: 'Hotels',
  },
  {
    ssic_code: '55102',
    title: 'Chalets',
  },
  {
    ssic_code: '55103',
    title: 'Short Term Accommodation Activities Other Than Hotels and Chalets',
  },
  {
    ssic_code: '55900',
    title:
      'Hostels and Dormitories for Students, Workers and Other Individuals',
  },
  {
    ssic_code: '56',
    title: 'Food and Beverage Service Activities',
  },
  {
    ssic_code: '561',
    title: 'Restaurants, Cafes, Food Courts, Food Kiosks and Bars',
  },
  {
    ssic_code: '5611',
    title: 'Restaurants and Cafes',
  },
  {
    ssic_code: '56111',
    title: 'Restaurants',
  },
  {
    ssic_code: '56112',
    title: 'Cafes',
  },
  {
    ssic_code: '5612',
    title: 'Fast Food Outlets, Food Courts and Food Kiosks',
  },
  {
    ssic_code: '56121',
    title: 'Fast Food Outlets',
  },
  {
    ssic_code: '56122',
    title:
      'Food Courts, Coffee Shops and Canteens (with Mainly Food and Beverage Income)',
  },
  {
    ssic_code: '56123',
    title: 'Food Kiosks Mainly for Takeaway and Delivery',
  },
  {
    ssic_code: '56130',
    title: 'Pubs',
  },
  {
    ssic_code: '5614',
    title: 'Stalls Selling Cooked Food and Prepared Drinks',
  },
  {
    ssic_code: '56140',
    title:
      'Stalls Selling Cooked Food and Prepared Drinks (including Stalls at Food Courts and Mobile Food Hawkers)',
  },
  {
    ssic_code: '56200',
    title: 'Food Caterers',
  },
  {
    ssic_code: '58',
    title: 'Publishing Activities',
  },
  {
    ssic_code: '581',
    title: 'Publishing of Books, Periodicals and Other Publishing Activities',
  },
  {
    ssic_code: '5811',
    title: 'Book Publishing',
  },
  {
    ssic_code: '58110',
    title:
      'Publishing of Books, Brochures, Musical Books and Other Publications',
  },
  {
    ssic_code: '5812',
    title: 'Publishing of Directories and Mailing Lists',
  },
  {
    ssic_code: '58120',
    title:
      'Publishing of Directories and Mailing Lists (including Financial Databases)',
  },
  {
    ssic_code: '5813',
    title: 'Publishing of News, Journals and Periodicals',
  },
  {
    ssic_code: '58131',
    title: 'Publishing of News',
  },
  {
    ssic_code: '58132',
    title: 'Publishing of Journals, Periodicals and Magazines',
  },
  {
    ssic_code: '5819',
    title: 'Other Publishing Activities',
  },
  {
    ssic_code: '58190',
    title: 'Other Publishing Activities (excluding Online Marketplaces)',
  },
  {
    ssic_code: '5820',
    title: 'Software Publishing',
  },
  {
    ssic_code: '58201',
    title: 'Publishing of Games Software/applications',
  },
  {
    ssic_code: '58202',
    title: 'Publishing of Software/applications (non-Games)',
  },
  {
    ssic_code: '59',
    title:
      'Movie, Video, Television and Other Programme Production, Sound Recording and Music Publishing Activities',
  },
  {
    ssic_code: '5911',
    title: 'Movie, Video, Television and Other Programme Production Activities',
  },
  {
    ssic_code: '59111',
    title: 'Movie Production',
  },
  {
    ssic_code: '59112',
    title: 'Production of Advertisements, Corporate Videos and Event Videos',
  },
  {
    ssic_code: '59113',
    title:
      'Production of Dramas, Variety Shows and Documentaries (including Production of Television Programme)',
  },
  {
    ssic_code: '59114',
    title: 'Animation Production',
  },
  {
    ssic_code: '59119',
    title:
      'Movie, Video, Television and Other Programme Production Activities n.e.c.',
  },
  {
    ssic_code: '5912',
    title:
      'Movie, Video, Television and Other Programme Post-Production Activities',
  },
  {
    ssic_code: '59120',
    title:
      'Movie, Video, Television and Other Programme Post-Production Activities (including Remastering)',
  },
  {
    ssic_code: '5913',
    title:
      'Movie, Video, Television and Other Programme Distribution Activities',
  },
  {
    ssic_code: '59131',
    title: 'Movie Distribution',
  },
  {
    ssic_code: '59132',
    title:
      'Distribution of Television Programmes (e.g. Dramas, Variety Shows and Documentaries)',
  },
  {
    ssic_code: '59139',
    title:
      'Movie, Video, Television and Other Programme Distribution Activities n.e.c.',
  },
  {
    ssic_code: '5914',
    title: 'Movie Projection Activities',
  },
  {
    ssic_code: '59140',
    title: 'Movie Projection Activities (including Cinemas)',
  },
  {
    ssic_code: '5920',
    title: 'Sound Recording and Music Publishing Activities',
  },
  {
    ssic_code: '59201',
    title: 'Sound Recording Production',
  },
  {
    ssic_code: '59202',
    title: 'Music Publishing and Distribution Activities',
  },
  {
    ssic_code: '60',
    title: 'Radio and Television Broadcasting Activities',
  },
  {
    ssic_code: '60100',
    title: 'Radio Programme Production and Broadcasting',
  },
  {
    ssic_code: '6020',
    title: 'Television Programming and Broadcasting',
  },
  {
    ssic_code: '60200',
    title:
      'Television Programming and Broadcasting (including Cable, Satellite, Terrestrial Television, Internet and Mobile)',
  },
  {
    ssic_code: '610',
    title: 'Telecommunications',
  },
  {
    ssic_code: '6101',
    title: 'Telecommunications Network Operation',
  },
  {
    ssic_code: '61011',
    title:
      'Wired Telecommunications Network Operation (including Fixed-Line, Fibre Optics, Local/international Pstn and Leased Circuits)',
  },
  {
    ssic_code: '61012',
    title:
      'Mobile Cellular and Other Wireless Telecommunications Network Operation',
  },
  {
    ssic_code: '61013',
    title: 'Satellite Telecommunications Network Operation',
  },
  {
    ssic_code: '6109',
    title: 'Other Telecommunications Activities',
  },
  {
    ssic_code: '61091',
    title:
      'Telecommunications Resellers/third Party Telecommunications Providers (including Value-Added Network Operators)',
  },
  {
    ssic_code: '61092',
    title: 'Internet Access Providers, Include Isps',
  },
  {
    ssic_code: '61099',
    title:
      'Other Telecommunications Activities n.e.c. (e.g. Provision of Voip (voice Over Internet Protocol Services))',
  },
  {
    ssic_code: '620',
    title:
      'Computer Programming, Information Technology Consultancy and Related Activities',
  },
  {
    ssic_code: '6201',
    title: 'Computer Programming Activities',
  },
  {
    ssic_code: '62011',
    title:
      'Development of Software and Applications (except Games and Cybersecurity)',
  },
  {
    ssic_code: '62012',
    title: 'Development of Computer Games',
  },
  {
    ssic_code: '62013',
    title: 'Development of Software for Cybersecurity',
  },
  {
    ssic_code: '6202',
    title:
      'Information Technology Consultancy and Computer Facilities Management Activities',
  },
  {
    ssic_code: '62021',
    title: 'Information Technology Consultancy (except Cybersecurity)',
  },
  {
    ssic_code: '62022',
    title: 'Information Technology Cybersecurity Consultancy',
  },
  {
    ssic_code: '62023',
    title: 'Computer Facilities Management Activities',
  },
  {
    ssic_code: '6209',
    title: 'Other Information Technology and Computer Service Activities',
  },
  {
    ssic_code: '62090',
    title:
      'Other Information Technology and Computer Service Activities (e.g. Disaster Recovery Services)',
  },
  {
    ssic_code: '63',
    title: 'Information Service Activities and Online Marketplaces',
  },
  {
    ssic_code: '631',
    title:
      'Data Analytics, Processing, Hosting and Related Activities; Internet Search Engines',
  },
  {
    ssic_code: '6311',
    title: 'Data Analytics Processing, Hosting and Related Activities',
  },
  {
    ssic_code: '63111',
    title: 'Data Centres',
  },
  {
    ssic_code: '63112',
    title: 'Hosting Services By Non-Data Centres',
  },
  {
    ssic_code: '63119',
    title: 'Data Analytics, Processing and Related Activities n.e.c.',
  },
  {
    ssic_code: '63120',
    title: 'Internet Search Engines',
  },
  {
    ssic_code: '6320',
    title: 'Online Marketplaces',
  },
  {
    ssic_code: '63201',
    title: 'Online Marketplaces for Goods (including Food)',
  },
  {
    ssic_code: '63202',
    title: 'Online Marketplaces for Health Services',
  },
  {
    ssic_code: '63203',
    title: 'Online Marketplaces for Education Services',
  },
  {
    ssic_code: '63204',
    title: 'Online Marketplaces for Travel Services',
  },
  {
    ssic_code: '63205',
    title: 'Online Marketplaces for Real Estate Services',
  },
  {
    ssic_code: '63209',
    title: 'Online Marketplaces for Services n.e.c.',
  },
  {
    ssic_code: '6390',
    title: 'Other Information Service Activities',
  },
  {
    ssic_code: '63901',
    title: 'News Agency Activities',
  },
  {
    ssic_code: '63909',
    title: 'Other Information Service Activities n.e.c.',
  },
  {
    ssic_code: '64',
    title: 'Financial Service Activities, Except Insurance and Pension Funding',
  },
  {
    ssic_code: '641',
    title: 'Monetary Intermediation',
  },
  {
    ssic_code: '64110',
    title: 'Central Bank',
  },
  {
    ssic_code: '64120',
    title: 'Full Banks',
  },
  {
    ssic_code: '64130',
    title: 'Wholesale Banks',
  },
  {
    ssic_code: '64140',
    title: 'Merchant Banks',
  },
  {
    ssic_code: '6415',
    title: 'Finance Companies',
  },
  {
    ssic_code: '64150',
    title: 'Finance Companies (with Deposit Taking Functions)',
  },
  {
    ssic_code: '64190',
    title: 'Other Monetary Intermediation',
  },
  {
    ssic_code: '6420',
    title: 'Activities of Holding Companies',
  },
  {
    ssic_code: '64201',
    title:
      'Bank/financial Holding Companies (including Insurance Holding Company)',
  },
  {
    ssic_code: '64202',
    title: 'Other Holding Companies',
  },
  {
    ssic_code: '6430',
    title: 'Trusts, Funds and Similar Financial Entities',
  },
  {
    ssic_code: '64300',
    title:
      'Trusts, Funds and Similar Financial Entities (e.g. Collective Portfolio Investment Funds (excluding Those with Rental Income))',
  },
  {
    ssic_code: '649',
    title:
      'Other Financial Services Activities, Except Insurance and Pension Funding Activities',
  },
  {
    ssic_code: '6491',
    title: 'Financial Leasing',
  },
  {
    ssic_code: '64910',
    title: 'Financial Leasing Companies',
  },
  {
    ssic_code: '6492',
    title: 'Other Credit Granting',
  },
  {
    ssic_code: '64921',
    title: 'Thrift and Loan Societies and Credit Associations',
  },
  {
    ssic_code: '64922',
    title: 'Credit Card Services',
  },
  {
    ssic_code: '64923',
    title: 'Mutual Benefits Organisations',
  },
  {
    ssic_code: '64924',
    title: 'Money-Lending',
  },
  {
    ssic_code: '64925',
    title: 'Pawnbrokerage',
  },
  {
    ssic_code: '64929',
    title: 'Other Credit Agencies n.e.c. (e.g. Motor Finance)',
  },
  {
    ssic_code: '6499',
    title:
      'Financial Service Activities, Except Insurance and Pension Funding Activities n.e.c.',
  },
  {
    ssic_code: '64991',
    title: 'Factoring Companies',
  },
  {
    ssic_code: '64992',
    title: 'Representative Offices of Foreign Banks',
  },
  {
    ssic_code: '64993',
    title: 'Remittance Services',
  },
  {
    ssic_code: '64994',
    title: 'Treasury Centres',
  },
  {
    ssic_code: '64999',
    title:
      'Other Financial Service Activities, Except Insurance and Pension Funding Activities n.e.c.',
  },
  {
    ssic_code: '65',
    title: 'Insurance, Reinsurance, Provident Funding and Pension Funding',
  },
  {
    ssic_code: '651',
    title: 'Insurance Underwriting',
  },
  {
    ssic_code: '6511',
    title: 'Life Insurance (insurance Underwriting)',
  },
  {
    ssic_code: '65110',
    title: 'Life Insurance',
  },
  {
    ssic_code: '6512',
    title: 'General Insurance (insurance Underwriting)',
  },
  {
    ssic_code: '65121',
    title: 'Marine Insurance',
  },
  {
    ssic_code: '65122',
    title: 'Captive Insurance',
  },
  {
    ssic_code: '65123',
    title: 'Import, Export and Credit Insurance',
  },
  {
    ssic_code: '65124',
    title:
      'General Insurance (except Marine and Import, Export & Credit Insurance)',
  },
  {
    ssic_code: '652',
    title: 'Reinsurance Underwriting',
  },
  {
    ssic_code: '6520',
    title: 'Reinsurance',
  },
  {
    ssic_code: '65201',
    title: 'Life Reinsurance',
  },
  {
    ssic_code: '65202',
    title: 'General Reinsurance',
  },
  {
    ssic_code: '6530',
    title: 'Provident and Pension Funding',
  },
  {
    ssic_code: '65301',
    title: 'Provident Funding',
  },
  {
    ssic_code: '65302',
    title: 'Pension Funding',
  },
  {
    ssic_code: '66',
    title: 'Activities Auxiliary to Financial Service and Insurance Activities',
  },
  {
    ssic_code: '661',
    title:
      'Activities Auxiliary to Financial Service Activities, Except Insurance and Pension Funding',
  },
  {
    ssic_code: '66110',
    title: 'Securities and Commodities Exchange',
  },
  {
    ssic_code: '6612',
    title: 'Security and Commodity Contracts Brokerage',
  },
  {
    ssic_code: '66121',
    title: 'Stock, Share and Bond Brokers and Dealers',
  },
  {
    ssic_code: '66122',
    title: 'Foreign Exchange Brokers and Dealers',
  },
  {
    ssic_code: '66123',
    title: 'Gold Bullion Brokers and Dealers',
  },
  {
    ssic_code: '66124',
    title: 'Commodity (excluding Gold) and Futures Brokers and Dealers',
  },
  {
    ssic_code: '66125',
    title: 'Carbon Credit Brokers/traders',
  },
  {
    ssic_code: '66126',
    title: 'Money-Changing Services',
  },
  {
    ssic_code: '66129',
    title:
      'Security Dealings and Commodity Contracts Brokerage Activities n.e.c.',
  },
  {
    ssic_code: '6619',
    title: 'Other Activities Auxiliary to Financial Service Activities',
  },
  {
    ssic_code: '66191',
    title:
      'Trustee, Fiduciary and Custody Services Firms (including Nominee Companies, Trustees and Reit Trustees)',
  },
  {
    ssic_code: '66192',
    title: 'Corporate Finance Advisory Services',
  },
  {
    ssic_code: '66193',
    title: 'Clearing and Settlement of Financial Instruments',
  },
  {
    ssic_code: '66194',
    title:
      'Activities Auxiliary to Fund Management Activities (e.g. Independent Fund Administration Firms)',
  },
  {
    ssic_code: '66195',
    title: 'Transaction/payment Processing Services',
  },
  {
    ssic_code: '66199',
    title:
      'Other Activities Auxiliary to Financial Service Activities n.e.c. (e.g. Mortgage Advisory Firms)',
  },
  {
    ssic_code: '662',
    title: 'Activities Auxiliary to Insurance and Pension Funding',
  },
  {
    ssic_code: '6621',
    title: 'Risk and Damage Evaluation',
  },
  {
    ssic_code: '66210',
    title: 'Risk and Damage Evaluation (e.g. Loss Adjusting, Claims Adjusting)',
  },
  {
    ssic_code: '6622',
    title: 'Activities of Insurance Intermediaries',
  },
  {
    ssic_code: '66221',
    title:
      'Insurance Agencies and Agents (including Financial Planning Services)',
  },
  {
    ssic_code: '66222',
    title: 'Insurance Brokers',
  },
  {
    ssic_code: '6629',
    title: 'Other Activities Auxiliary to Insurance and Pension Funding',
  },
  {
    ssic_code: '66291',
    title:
      'Representative Offices of Foreign Insurers and Professional Reinsurers',
  },
  {
    ssic_code: '66292',
    title: 'Captive Managers',
  },
  {
    ssic_code: '66299',
    title:
      'Other Activities Auxiliary to Insurance and Pension Funding n.e.c. (e.g. Activities of Actuaries)',
  },
  {
    ssic_code: '6630',
    title: 'Fund Management Activities',
  },
  {
    ssic_code: '66301',
    title: 'Traditional/long-Only Asset/portfolio Management',
  },
  {
    ssic_code: '66302',
    title: 'Hedge Fund Management',
  },
  {
    ssic_code: '66303',
    title:
      'Property Fund Management (including Reit Management and Direct Property Fund Management)',
  },
  {
    ssic_code: '66304',
    title: 'Private Equity Firms',
  },
  {
    ssic_code: '66305',
    title: 'Venture Capital Activities',
  },
  {
    ssic_code: '66306',
    title:
      'Single/multiple Family Offices Activities (e.g. Managing Investments and Trusts for A Single or Multiple Families)',
  },
  {
    ssic_code: '66307',
    title: 'Private Debt Funds',
  },
  {
    ssic_code: '66309',
    title: 'Fund Management Activities n.e.c.',
  },
  {
    ssic_code: '68',
    title: 'Real Estate Activities',
  },
  {
    ssic_code: '6810',
    title: 'Real Estate Activities with Own or Leased Property',
  },
  {
    ssic_code: '68101',
    title: 'Real Estate Developers',
  },
  {
    ssic_code: '68102',
    title: 'Operating of Serviced Apartments',
  },
  {
    ssic_code: '68103',
    title:
      'Letting of Self-Owned or Leased Real Estate Property Except Food Courts, Coffee Shops and Canteens (e.g. Office/exhibition Space, Shopping Mall, Self-Storage Facilities)',
  },
  {
    ssic_code: '68104',
    title:
      'Letting and Operating of Self-Owned or Leased Food Courts, Coffee Shops and Canteens (with Mainly Rental Income)',
  },
  {
    ssic_code: '68105',
    title: 'Collective Portfolio Investment Funds with Rental Income',
  },
  {
    ssic_code: '68106',
    title:
      'Management of Self-Owned Strata Titled Property (i.e. Management Corporation Strata Title)',
  },
  {
    ssic_code: '6820',
    title: 'Real Estate Activities on A Fee or Commission Basis',
  },
  {
    ssic_code: '68201',
    title: 'Real Estate Agencies and Valuation Services',
  },
  {
    ssic_code: '68202',
    title: 'Town Councils',
  },
  {
    ssic_code: '68203',
    title:
      'Residential (other Than Town Councils), Commercial and Industrial Real Estate Management',
  },
  {
    ssic_code: '68209',
    title:
      'Real Estate Activities on A Fee or Commission Basis n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '69',
    title: 'Legal and Accounting Activities',
  },
  {
    ssic_code: '6910',
    title: 'Legal Activities',
  },
  {
    ssic_code: '69101',
    title: 'Legal Activities (excluding Online Marketplaces)',
  },
  {
    ssic_code: '69102',
    title: 'Arbitration and Mediation Services (excluding Online Marketplaces)',
  },
  {
    ssic_code: '6920',
    title: 'Accounting, Book-Keeping and Auditing Activities; Tax Consultancy',
  },
  {
    ssic_code: '69201',
    title: 'Accounting and Auditing Services (excluding Online Marketplaces)',
  },
  {
    ssic_code: '69202',
    title: 'Book-Keeping Services (excluding Online Marketplaces)',
  },
  {
    ssic_code: '70',
    title: 'Activities of Head Offices; Management Consultancy Activities',
  },
  {
    ssic_code: '7010',
    title:
      'Activities of Head Offices; Centralised Administrative Offices and Business Representative Offices',
  },
  {
    ssic_code: '70101',
    title:
      'Activities of Head and Regional Head Offices; Centralised Administrative Offices and Subsidiary Management Offices',
  },
  {
    ssic_code: '70102',
    title: 'Business Representative Offices',
  },
  {
    ssic_code: '7020',
    title: 'Management Consultancy Activities',
  },
  {
    ssic_code: '70201',
    title: 'Management Consultancy Services',
  },
  {
    ssic_code: '70202',
    title: 'Management Consultancy Services for Healthcare Organisations',
  },
  {
    ssic_code: '70203',
    title: 'Management Consultancy Services for Hotels',
  },
  {
    ssic_code: '70204',
    title: 'Human Resource Consultancy Services',
  },
  {
    ssic_code: '70205',
    title: 'Public Relations, Marketing and Brand Consultancy Services',
  },
  {
    ssic_code: '70206',
    title: 'Port, Shipping and Maritime-Related Consultancy Services',
  },
  {
    ssic_code: '70209',
    title: 'Management Consultancy Services n.e.c.',
  },
  {
    ssic_code: '71',
    title:
      'Architectural and Engineering Activities; Technical Testing and Analysis',
  },
  {
    ssic_code: '711',
    title:
      'Architectural and Engineering Activities and Related Technical Consultancy',
  },
  {
    ssic_code: '7111',
    title: 'Architectural and Surveying Activities',
  },
  {
    ssic_code: '71111',
    title: 'Architectural Services',
  },
  {
    ssic_code: '71112',
    title: 'Landscape Design and Landscape Architecture',
  },
  {
    ssic_code: '71113',
    title: 'Quantity Surveying Services',
  },
  {
    ssic_code: '71114',
    title: 'Land Surveying Services',
  },
  {
    ssic_code: '71119',
    title:
      'Other Surveying Services n.e.c. (e.g. Geophysical, Geologic, Seismic, Hydrographic Surveying Services)',
  },
  {
    ssic_code: '7112',
    title: 'Engineering Design and Consultancy Activities',
  },
  {
    ssic_code: '71121',
    title: 'General Building Engineering Design and Consultancy Services',
  },
  {
    ssic_code: '71122',
    title:
      'Process and Industrial Plant Engineering Design and Consultancy Services',
  },
  {
    ssic_code: '71123',
    title:
      'Engineering Design and Consultancy Services in Energy Management and Clean Energy Systems',
  },
  {
    ssic_code: '71124',
    title:
      'Environmental Engineering Design and Consultancy Services (except Clean Energy)',
  },
  {
    ssic_code: '71125',
    title: 'Infrastructure Engineering Design and Consultancy Services',
  },
  {
    ssic_code: '71126',
    title:
      'Engineering Design and Consultancy Services Supporting Mining, Oil and Gas Extraction and Offshore Exploration Activities',
  },
  {
    ssic_code: '71129',
    title: 'Engineering Design and Consultancy Activities n.e.c.',
  },
  {
    ssic_code: '7120',
    title: 'Technical Testing and Analysis Services',
  },
  {
    ssic_code: '71200',
    title:
      'Technical Testing and Analysis Services (including Certification of Products and Services)',
  },
  {
    ssic_code: '72',
    title: 'Scientific Research and Development',
  },
  {
    ssic_code: '7210',
    title:
      'Research and Experimental Development on Natural Sciences and Engineering',
  },
  {
    ssic_code: '72101',
    title:
      'Research and Experimental Development on Biotechnology (excluding Medical Science)',
  },
  {
    ssic_code: '72102',
    title:
      'Research and Experimental Development on Electronics (excluding Medical Science)',
  },
  {
    ssic_code: '72103',
    title:
      'Research and Experimental Development on Chemicals (excluding Medical Science)',
  },
  {
    ssic_code: '72104',
    title: 'Research and Experimental Development on Engineering',
  },
  {
    ssic_code: '72105',
    title:
      'Research and Experimental Development on Environment and Clean Technologies (excluding Biotechnology)',
  },
  {
    ssic_code: '72106',
    title: 'Research and Experimental Development on Medical Science',
  },
  {
    ssic_code: '72109',
    title: 'Research and Experimental Development on Natural Sciences n.e.c.',
  },
  {
    ssic_code: '72200',
    title:
      'Research and Experimental Development on Social Sciences and Humanities',
  },
  {
    ssic_code: '73',
    title: 'Advertising and Market Research',
  },
  {
    ssic_code: '7310',
    title: 'Advertising',
  },
  {
    ssic_code: '73100',
    title: 'Advertising Activities',
  },
  {
    ssic_code: '73200',
    title: 'Market Research and Public Opinion Polling',
  },
  {
    ssic_code: '74',
    title: 'Other Professional, Scientific and Technical Activities',
  },
  {
    ssic_code: '741',
    title: 'Specialised Design Activities',
  },
  {
    ssic_code: '7411',
    title: 'Industrial Design Activities',
  },
  {
    ssic_code: '74111',
    title: 'Electronics-Related Industrial Design Services',
  },
  {
    ssic_code: '74112',
    title: 'Transport-Related Industrial Design Services',
  },
  {
    ssic_code: '74113',
    title: 'Furniture Design Services',
  },
  {
    ssic_code: '74119',
    title: 'Industrial Design Activities n.e.c.',
  },
  {
    ssic_code: '7419',
    title: 'Other Specialised Design Activities',
  },
  {
    ssic_code: '74191',
    title: 'Interior Design Services',
  },
  {
    ssic_code: '74192',
    title: 'Art and Graphic Design Services',
  },
  {
    ssic_code: '74193',
    title: 'Fashion (including Accessories) Design Services',
  },
  {
    ssic_code: '74194',
    title: 'Exhibition Stand Design Services',
  },
  {
    ssic_code: '74199',
    title: 'Other Specialised Design Activities n.e.c.',
  },
  {
    ssic_code: '74200',
    title: 'Photographic Activities',
  },
  {
    ssic_code: '7490',
    title: 'Professional, Scientific and Technical Activities n.e.c.',
  },
  {
    ssic_code: '74901',
    title: 'Translation Services',
  },
  {
    ssic_code: '74902',
    title: 'Brokerage and Consultancy Services of Intellectual Property Assets',
  },
  {
    ssic_code: '74903',
    title: 'Agrotechnology Consultancy Services',
  },
  {
    ssic_code: '74904',
    title: 'Carbon Consultancy Services',
  },
  {
    ssic_code: '74905',
    title: 'Agents for Artistes, Athletes, Models and Other Performers',
  },
  {
    ssic_code: '74909',
    title: 'Other Professional, Scientific and Technical Activities n.e.c.',
  },
  {
    ssic_code: '75000',
    title: 'Veterinary Activities',
  },
  {
    ssic_code: '77',
    title: 'Rental and Leasing Activities',
  },
  {
    ssic_code: '7710',
    title: 'Renting and Leasing of Land Transport Equipment',
  },
  {
    ssic_code: '77101',
    title:
      'Renting and Leasing of Private Cars Without Driver (excluding Online Marketplaces)',
  },
  {
    ssic_code: '77102',
    title: 'Renting and Leasing of Bicycles and Inline/roller Skates',
  },
  {
    ssic_code: '77109',
    title:
      'Renting and Leasing of Land Transport Equipment (except Cars) Without Driver n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '772',
    title: 'Renting and Leasing of Personal and Household Goods',
  },
  {
    ssic_code: '77210',
    title: 'Renting and Leasing of Recreational and Sports Goods',
  },
  {
    ssic_code: '77220',
    title: 'Renting of Vcds and Dvds',
  },
  {
    ssic_code: '7729',
    title: 'Renting and Leasing of Other Personal and Household Goods',
  },
  {
    ssic_code: '77291',
    title:
      'Renting and Leasing of Furniture, Utensils and Electronic Equipment for Household Use',
  },
  {
    ssic_code: '77292',
    title: 'Renting of Attire (e.g. Costumes)',
  },
  {
    ssic_code: '77299',
    title:
      'Renting and Leasing of Other Personal and Household Goods n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '773',
    title:
      'Renting and Leasing of Other Machinery, Equipment and Tangible Goods',
  },
  {
    ssic_code: '7731',
    title: 'Renting of Water Transport Equipment',
  },
  {
    ssic_code: '77310',
    title:
      'Renting of Water Transport Equipment Without Operator (e.g. Commercial Boats and Ships Without Operator)',
  },
  {
    ssic_code: '7732',
    title: 'Renting of Air Transport Equipment',
  },
  {
    ssic_code: '77320',
    title:
      'Renting of Air Transport Equipment Without Operator (e.g. Airplanes Without Operator)',
  },
  {
    ssic_code: '77330',
    title:
      'Renting of Construction and Civil Engineering Machinery and Equipment',
  },
  {
    ssic_code: '7734',
    title: 'Renting of Office Machinery and Equipment (including Computers)',
  },
  {
    ssic_code: '77341',
    title: 'Renting of Computers and Peripheral Equipment',
  },
  {
    ssic_code: '77342',
    title: 'Renting of Office Machinery and Equipment',
  },
  {
    ssic_code: '7739',
    title: 'Renting of Machinery, Equipment and Tangible Goods n.e.c.',
  },
  {
    ssic_code: '77391',
    title:
      'Renting and Leasing of Professional Radio and Television Sets and Sound Reproducing and Recording Equipment',
  },
  {
    ssic_code: '77392',
    title: 'Renting of Industrial Machinery and Equipment',
  },
  {
    ssic_code: '77399',
    title:
      'Renting of Other Machinery, Equipment and Tangible Goods n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '7740',
    title: 'Leasing of Non-Financial Intangible Assets',
  },
  {
    ssic_code: '77400',
    title:
      'Leasing of Non-Financial Intangible Assets (e.g. Patents, Trade Marks, Brand Names Etc)',
  },
  {
    ssic_code: '78',
    title: 'Employment Activities',
  },
  {
    ssic_code: '7810',
    title: 'Employment and Recruitment Agencies',
  },
  {
    ssic_code: '78101',
    title: 'IT Manpower Contracting Services',
  },
  {
    ssic_code: '78102',
    title: 'Manpower Contracting Services (excluding IT Manpower)',
  },
  {
    ssic_code: '78103',
    title:
      'Domestic Worker Employment Placement Agencies (excluding Online Marketplaces)',
  },
  {
    ssic_code: '78104',
    title:
      'Employment Agencies (excluding Domestic Worker Employment Placement Agencies and Online Marketplaces)',
  },
  {
    ssic_code: '78300',
    title: 'Management of Human Resource Functions',
  },
  {
    ssic_code: '79',
    title: 'Travel Agencies, Tour Operators and Timesharing Service Activities',
  },
  {
    ssic_code: '7910',
    title: 'Travel Agencies and Tour Operators Activities',
  },
  {
    ssic_code: '79101',
    title: 'Travel Agencies and Tour Operators (mainly Inbound)',
  },
  {
    ssic_code: '79102',
    title: 'Travel Agencies and Tour Operators (mainly Outbound)',
  },
  {
    ssic_code: '79200',
    title: 'Timesharing Service Activities',
  },
  {
    ssic_code: '8',
    title: 'Mining and Quarrying',
  },
  {
    ssic_code: '80',
    title: 'Security and Investigation Activities',
  },
  {
    ssic_code: '80100',
    title: 'Private Security Activities',
  },
  {
    ssic_code: '80200',
    title: 'Detective and Investigation Activities',
  },
  {
    ssic_code: '81',
    title: 'Cleaning and Landscape Maintenance Activities',
  },
  {
    ssic_code: '810',
    title: 'Quarrying of Stone, Sand and Clay',
  },
  {
    ssic_code: '8101',
    title: 'Stone Quarrying',
  },
  {
    ssic_code: '8102',
    title: 'Quarrying of Sand and Clay',
  },
  {
    ssic_code: '812',
    title: 'Cleaning Activities',
  },
  {
    ssic_code: '8121',
    title: 'General Cleaning Services',
  },
  {
    ssic_code: '81211',
    title:
      'General Cleaning Services (including Cleaning of Public Areas, Offices and Factories) Except Household Cleaning and Online Marketplaces',
  },
  {
    ssic_code: '81212',
    title:
      'Domestic/household Cleaning Services (excluding Online Marketplaces)',
  },
  {
    ssic_code: '8129',
    title: 'Other Cleaning Services',
  },
  {
    ssic_code: '81291',
    title: 'Pest Control Services Not in Connection with Agriculture',
  },
  {
    ssic_code: '81292',
    title: 'Cleaning of Swimming Pools, Spas and Fountains',
  },
  {
    ssic_code: '81299',
    title: 'Other Cleaning Services n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '8130',
    title: 'Landscape Planting, Care and Maintenance Service Activities',
  },
  {
    ssic_code: '81300',
    title:
      'Landscape Planting, Care and Maintenance Service Activities (e.g. Garden Installation and Maintenance, Grass Cutting, Tree Felling, Pruning)',
  },
  {
    ssic_code: '82',
    title:
      'Office Administrative, Office Support and Other Business Support Activities',
  },
  {
    ssic_code: '821',
    title: 'Office Administrative and Support Activities',
  },
  {
    ssic_code: '8211',
    title: 'Combined Office Administrative Service Activities',
  },
  {
    ssic_code: '82110',
    title:
      'Office Administrative Services on A Fee or Contract Basis (e.g. Billing and Record Keeping)',
  },
  {
    ssic_code: '8219',
    title:
      'Photocopying, Document Preparation and Other Specialised Office Support Activities',
  },
  {
    ssic_code: '82191',
    title: 'Stenographic and Secretarial Services',
  },
  {
    ssic_code: '82192',
    title: 'Duplicating and Photo-Copying Services',
  },
  {
    ssic_code: '82199',
    title: 'Other Specialised Office Support Activities n.e.c.',
  },
  {
    ssic_code: '8220',
    title: 'Activities of Call Centres',
  },
  {
    ssic_code: '82200',
    title: 'Call Centres',
  },
  {
    ssic_code: '8230',
    title: 'Convention, Trade Show, Concert and Other Event Organisers',
  },
  {
    ssic_code: '82301',
    title: 'Exhibition Organisers',
  },
  {
    ssic_code: '82302',
    title: 'Convention/conference Organisers',
  },
  {
    ssic_code: '82303',
    title: 'Event/concert Organisers',
  },
  {
    ssic_code: '82304',
    title: 'Exhibition Stand Contractors',
  },
  {
    ssic_code: '829',
    title: 'Business Support Service Activities n.e.c.',
  },
  {
    ssic_code: '8291',
    title: 'Activities of Collection Agencies and Credit Bureaus',
  },
  {
    ssic_code: '82911',
    title: 'Debt Collection Services',
  },
  {
    ssic_code: '82912',
    title: 'Credit Rating Agencies',
  },
  {
    ssic_code: '82920',
    title: 'Packaging Activities',
  },
  {
    ssic_code: '8299',
    title: 'Other Business Support Service Activities n.e.c.',
  },
  {
    ssic_code: '82991',
    title: 'Activities of Auction Houses',
  },
  {
    ssic_code: '82999',
    title:
      'Other Business Support Service Activities (e.g. Administration of Loyalty Programmes)',
  },
  {
    ssic_code: '84',
    title: 'Public Administration and Defence',
  },
  {
    ssic_code: '841',
    title:
      'Administration of the State and the Economic and Social Policy of the Community',
  },
  {
    ssic_code: '8411',
    title: 'General Public Administration',
  },
  {
    ssic_code: '84110',
    title:
      'Executive, Legislative and Other General Public Administration (e.g. Istana, Parliament, Tax Authority)',
  },
  {
    ssic_code: '84120',
    title: 'Public Administration of Economic and Social Programmes',
  },
  {
    ssic_code: '842',
    title: 'Provision of Services to the Community As A Whole',
  },
  {
    ssic_code: '84210',
    title: 'Foreign Affairs',
  },
  {
    ssic_code: '8422',
    title: 'Defence Activities',
  },
  {
    ssic_code: '84221',
    title: 'Armed Forces',
  },
  {
    ssic_code: '84229',
    title: 'Defence Activities n.e.c.',
  },
  {
    ssic_code: '8423',
    title: 'Public Order and Safety Activities',
  },
  {
    ssic_code: '84231',
    title: 'Judiciary and Related Services',
  },
  {
    ssic_code: '84232',
    title: 'Police',
  },
  {
    ssic_code: '84233',
    title: 'Prisons',
  },
  {
    ssic_code: '84234',
    title: 'Other Places of Detention, Correction and Rehabilitation',
  },
  {
    ssic_code: '84235',
    title: 'Civil Defence',
  },
  {
    ssic_code: '84239',
    title: 'Public Order and Safety Activities n.e.c.',
  },
  {
    ssic_code: '85',
    title: 'Education',
  },
  {
    ssic_code: '8510',
    title: 'Pre-Primary and Primary Education',
  },
  {
    ssic_code: '85101',
    title: 'Nurseries and Kindergartens',
  },
  {
    ssic_code: '85102',
    title: 'Primary Schools',
  },
  {
    ssic_code: '852',
    title: 'Secondary and Post-Secondary Non-Tertiary Education',
  },
  {
    ssic_code: '8521',
    title: 'General Secondary and Post-Secondary Non-Tertiary Education',
  },
  {
    ssic_code: '85211',
    title: 'Secondary Schools Including Combined Primary and Secondary Schools',
  },
  {
    ssic_code: '85212',
    title:
      'Junior Colleges and Centralised Pre-University Institutes (post-Secondary Non-Tertiary) Including Combined Secondary Schools and Post-Secondary Non-Tertiary Schools',
  },
  {
    ssic_code: '85213',
    title:
      'Commercial Schools Offering General Secondary and Post-Secondary Non-Tertiary Education Programmes',
  },
  {
    ssic_code: '8522',
    title:
      'Technical and Vocational (secondary and Post-Secondary Non-Tertiary) Education',
  },
  {
    ssic_code: '85220',
    title:
      'Technical and Vocational Secondary and Post-Secondary Non-Tertiary Education',
  },
  {
    ssic_code: '85230',
    title: 'International and Foreign System Schools',
  },
  {
    ssic_code: '85240',
    title: 'Schools for Special Needs',
  },
  {
    ssic_code: '85250',
    title: 'Specialised Education Schools',
  },
  {
    ssic_code: '8530',
    title: 'Higher Education',
  },
  {
    ssic_code: '85301',
    title: 'Polytechnics',
  },
  {
    ssic_code: '85302',
    title: 'Universities',
  },
  {
    ssic_code: '85303',
    title: "Teachers' Training Institute",
  },
  {
    ssic_code: '85304',
    title: 'Commercial Schools Offering Higher Education Programmes',
  },
  {
    ssic_code: '8540',
    title: 'Other Education',
  },
  {
    ssic_code: '85401',
    title:
      'Training Courses for Construction, Real Estate, Security and Investigation Services, Cleaning, Landscaping, Waste Management and Pest Management',
  },
  {
    ssic_code: '85402',
    title:
      'Training Courses for Healthcare, Education, Community and Social Services',
  },
  {
    ssic_code: '85403',
    title:
      'Training Courses for Food and Beverage, Retail and Accommodation, Tour Operators, Travel Agencies & Travel-Related Reservation Services',
  },
  {
    ssic_code: '85404',
    title: 'Training Courses for Manufacturing',
  },
  {
    ssic_code: '85405',
    title:
      'Training Courses for Information and Communications, Finance and Professional Services',
  },
  {
    ssic_code: '85406',
    title: 'Training Courses for Wholesale Trade, Logistics and Transport',
  },
  {
    ssic_code: '85407',
    title: 'Training Courses for Sports and Games',
  },
  {
    ssic_code: '85408',
    title: 'Training Courses for Music, Dancing, Art, Speech and Drama',
  },
  {
    ssic_code: '85409',
    title: 'Training Courses n.e.c.',
  },
  {
    ssic_code: '8550',
    title: 'Educational Support Services',
  },
  {
    ssic_code: '85501',
    title: 'Student Recruitment Agencies',
  },
  {
    ssic_code: '85502',
    title: 'Examination and Accreditation Agencies for Education Services',
  },
  {
    ssic_code: '85509',
    title:
      'Educational Support Services n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '86',
    title: 'Health Services',
  },
  {
    ssic_code: '8610',
    title: 'Hospital Activities',
  },
  {
    ssic_code: '86101',
    title: 'Acute Hospitals',
  },
  {
    ssic_code: '86102',
    title: 'Community Hospitals',
  },
  {
    ssic_code: '86109',
    title: 'Other Hospitals n.e.c. (e.g. Psychiatric Hospital)',
  },
  {
    ssic_code: '8620',
    title: 'Medical and Dental Practice Activities',
  },
  {
    ssic_code: '86201',
    title: 'Clinics and Other General Medical Services (western)',
  },
  {
    ssic_code: '86202',
    title: 'Clinics and Other General Medical Services (non-Western)',
  },
  {
    ssic_code: '86203',
    title: 'Specialised Medical Services (including Day Surgical Centres)',
  },
  {
    ssic_code: '86204',
    title: 'Dental Services',
  },
  {
    ssic_code: '8690',
    title: 'Other Health Services',
  },
  {
    ssic_code: '86901',
    title: 'Medical Laboratories (e.g. Blood Analysis Laboratories)',
  },
  {
    ssic_code: '86902',
    title: 'Medical Diagnostic Imaging Centres (e.g. X-Ray Services)',
  },
  {
    ssic_code: '86903',
    title: 'Ambulance and Medical Evacuation Services',
  },
  {
    ssic_code: '86904',
    title: 'Home Healthcare Services',
  },
  {
    ssic_code: '86905',
    title: 'Dialysis Services',
  },
  {
    ssic_code: '86909',
    title: 'Other Health Services n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '870',
    title: 'Residential Care Services',
  },
  {
    ssic_code: '8701',
    title: 'Residential Nursing Care Facilities',
  },
  {
    ssic_code: '87010',
    title:
      'Nursing and Personal Care Facilities (including Nursing Homes and Hospices)',
  },
  {
    ssic_code: '8702',
    title: 'Other Residential Care Services',
  },
  {
    ssic_code: '87021',
    title: 'Residential Care Services for the Elderly (e.g. Home for the Aged)',
  },
  {
    ssic_code: '87022',
    title:
      'Residential Care Services for Children (e.g. Children’s Homes, Orphanages)',
  },
  {
    ssic_code: '87029',
    title: 'Other Residential Care Services n.e.c.',
  },
  {
    ssic_code: '88',
    title: 'Social Services Without Accommodation',
  },
  {
    ssic_code: '8810',
    title: 'Social Services Without Accommodation for the Elderly and Disabled',
  },
  {
    ssic_code: '88101',
    title:
      'Social Services for the Elderly (e.g. Befriender Services, Meal Services, Drop-In Centres)',
  },
  {
    ssic_code: '88102',
    title:
      'Social Services for Persons with Disabilities (e.g. Day Activity Centres for People with Disabilities)',
  },
  {
    ssic_code: '889',
    title: 'Other Social Services Without Accommodation',
  },
  {
    ssic_code: '8891',
    title:
      'Social Services Without Accommodation for Children, Youth and Families',
  },
  {
    ssic_code: '88911',
    title:
      'Child Care Services for Pre-School Children (including Infant Care Services)',
  },
  {
    ssic_code: '88912',
    title:
      'Child/student Care Services for School-Going Children (e.g. Before and After-School Care Centres, Student Care Centres)',
  },
  {
    ssic_code: '88913',
    title:
      'Social Services for Children and Youths (e.g. Youth Outreach Services, Adoption Services)',
  },
  {
    ssic_code: '88919',
    title:
      'Social Services Without Accommodation for Children, Youth and Families n.e.c.',
  },
  {
    ssic_code: '8892',
    title: 'Community Activities',
  },
  {
    ssic_code: '88920',
    title: 'Community Development Councils and Grassroots Organisations',
  },
  {
    ssic_code: '8899',
    title: 'Social Services Without Accommodation n.e.c.',
  },
  {
    ssic_code: '88991',
    title: 'Job Training and Vocational Rehabilitation Services',
  },
  {
    ssic_code: '88992',
    title:
      'Charitable and Other Supporting Activities Aimed at Humanitarian Work',
  },
  {
    ssic_code: '88999',
    title: 'Other Social Services Without Accommodation n.e.c.',
  },
  {
    ssic_code: '8900',
    title: 'Other Mining and Quarrying',
  },
  {
    ssic_code: '9000',
    title: 'Creative, Arts and Entertainment Activities',
  },
  {
    ssic_code: '90001',
    title: 'Production of Live Stage Presentations',
  },
  {
    ssic_code: '90002',
    title: 'Performing Arts Venue Operation',
  },
  {
    ssic_code: '90003',
    title: 'Orchestras, Musical Bands, Choirs and Dance Groups',
  },
  {
    ssic_code: '90009',
    title:
      'Dramatic Arts, Music and Other Arts Production-Related Activities n.e.c. (e.g. Stage, Lighting and Sound Services)',
  },
  {
    ssic_code: '9001',
    title: 'Crude Petroleum and Natural Gas Production',
  },
  {
    ssic_code: '9002',
    title:
      'Service Activities Incidental to Oil and Gas Extraction (excluding Surveying and Engineering Design and Consultancy Services Supporting Mining, Oil and Gas Extraction and Offshore Exploration Activities)',
  },
  {
    ssic_code: '910',
    title: 'Libraries, Archives, Museums and Other Cultural Activities',
  },
  {
    ssic_code: '91010',
    title: 'Libraries and Archives Activities',
  },
  {
    ssic_code: '9102',
    title: 'Museums Activities and Operation of Historical Sites and Buildings',
  },
  {
    ssic_code: '91021',
    title: 'Museums',
  },
  {
    ssic_code: '91029',
    title:
      'Preservation of Historical Sites, Buildings, Artefacts and Paintings, Cultural Villages and Other Related Activities n.e.c.',
  },
  {
    ssic_code: '91030',
    title: 'Botanical and Zoological Gardens and Nature Reserves Activities',
  },
  {
    ssic_code: '9200',
    title: 'Gambling and Betting Activities',
  },
  {
    ssic_code: '92001',
    title: 'Horse-Racing and Other Betting Activities',
  },
  {
    ssic_code: '92002',
    title: 'Casinos',
  },
  {
    ssic_code: '93',
    title: 'Sports Activities and Amusement and Recreation Activities',
  },
  {
    ssic_code: '931',
    title: 'Sports Activities',
  },
  {
    ssic_code: '9311',
    title: 'Operation of Sports Facilities',
  },
  {
    ssic_code: '93111',
    title: 'Fitness Centres and Gymnasiums',
  },
  {
    ssic_code: '93119',
    title:
      'Operation of Sports Facilities n.e.c. (e.g. Bowling Alleys, Tennis Centres, Billiard Halls, Football Stadium)',
  },
  {
    ssic_code: '93120',
    title: 'Activities of Sports Clubs/associations and Related Activities',
  },
  {
    ssic_code: '9320',
    title: 'Other Amusement and Recreation Activities',
  },
  {
    ssic_code: '93201',
    title: 'Amusement Theme Parks',
  },
  {
    ssic_code: '93202',
    title:
      'Game Arcade, Online Game Aggregator, Lan Game Operators and Gaming Centres',
  },
  {
    ssic_code: '93203',
    title: 'Night Clubs, Discotheques, Dance Clubs and Karaoke Lounges',
  },
  {
    ssic_code: '93204',
    title: 'Recreation Clubs (including Country Clubs)',
  },
  {
    ssic_code: '93209',
    title:
      'Other Amusement and Recreation Activities n.e.c. (including Recreation Parks/beaches and Recreational Fishing)',
  },
  {
    ssic_code: '94',
    title: 'Activities of Membership Organisations',
  },
  {
    ssic_code: '941',
    title:
      'Activities of Business, Employers and Professional Membership Organisations',
  },
  {
    ssic_code: '94110',
    title: "Activities of Business and Employers' Membership Organisations",
  },
  {
    ssic_code: '9412',
    title: 'Activities of Professional Membership Organisations',
  },
  {
    ssic_code: '94120',
    title:
      'Activities of Professional Membership Organisations (e.g. Medical Associations, Law Societies, Accountancy Bodies)',
  },
  {
    ssic_code: '94200',
    title: 'Activities of Trade Unions',
  },
  {
    ssic_code: '949',
    title: 'Activities of Other Membership Organisations',
  },
  {
    ssic_code: '9491',
    title: 'Activities of Religious Organisations',
  },
  {
    ssic_code: '94911',
    title: 'Churches',
  },
  {
    ssic_code: '94912',
    title: 'Mosques',
  },
  {
    ssic_code: '94913',
    title: 'Buddhist/taoist Temples',
  },
  {
    ssic_code: '94914',
    title: 'Hindu/sikh Temples',
  },
  {
    ssic_code: '94919',
    title: 'Activities of Religious Organisations n.e.c.',
  },
  {
    ssic_code: '94920',
    title: 'Activities of Political Organisations',
  },
  {
    ssic_code: '94991',
    title: 'Philanthropic Trusts, Foundations and Related Activities',
  },
  {
    ssic_code: '94992',
    title: 'Ethnic Associations (including Clan Associations, Huay Kuans)',
  },
  {
    ssic_code: '94993',
    title:
      'Associations for Hobbies, Recreational, Cultural and Extra-Curricular Activities (e.g. Scouts/girl Guides Association, Book Clubs and Photo, Music, Art and Craft Clubs)',
  },
  {
    ssic_code: '94994',
    title:
      "Student/alumni Bodies and Related Associations (e.g. Parent-Teacher Associations, Old Boys' Associations)",
  },
  {
    ssic_code: '94995',
    title: 'Organisations for the Protection of the Environment and Animals',
  },
  {
    ssic_code: '94999',
    title: 'Activities of Other Membership Organisations n.e.c.',
  },
  {
    ssic_code: '95',
    title: 'Repair of Computers, Personal and Household Goods and Vehicles',
  },
  {
    ssic_code: '951',
    title: 'Repair of Computers and Communications Equipment',
  },
  {
    ssic_code: '9511',
    title: 'Repair of Computers and Peripheral Equipment',
  },
  {
    ssic_code: '95110',
    title:
      'Repair and Maintenance of Computer Hardware, Data Processing Equipment and Computer Peripherals',
  },
  {
    ssic_code: '9512',
    title: 'Repair of Communications Equipment',
  },
  {
    ssic_code: '95120',
    title:
      'Repair of Communications Equipment (e.g. Mobile Phones and Fax Machines)',
  },
  {
    ssic_code: '952',
    title: 'Repair of Personal and Household Goods',
  },
  {
    ssic_code: '9521',
    title: 'Repair of Consumer Electronics',
  },
  {
    ssic_code: '95210',
    title:
      'Repair of Audio and Video Equipment (e.g. Television Sets, Speakers and Dvd Players)',
  },
  {
    ssic_code: '9522',
    title: 'Repair of Household Appliances and Home and Garden Equipment',
  },
  {
    ssic_code: '95220',
    title:
      'Repair of Domestic Electrical/electronic Appliances Except Audio and Video Equipment (e.g. Refrigerators, Washing Machines and Room Air-Conditioners)',
  },
  {
    ssic_code: '95230',
    title: 'Repair of Footwear and Leather Goods',
  },
  {
    ssic_code: '9524',
    title: 'Repair of Furniture and Home Furnishings',
  },
  {
    ssic_code: '95240',
    title:
      'Repair and Restoration of Cabinets, Furniture, Upholstery, Window Shades and Other Fixtures',
  },
  {
    ssic_code: '9529',
    title: 'Repair of Other Personal and Household Goods',
  },
  {
    ssic_code: '95291',
    title: 'Repair of Bicycles and Tricycles',
  },
  {
    ssic_code: '95292',
    title: 'Repair of Watches and Clocks',
  },
  {
    ssic_code: '95293',
    title: 'Repair of Jewellery',
  },
  {
    ssic_code: '95299',
    title:
      'Repair of Other Personal and Household Goods n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '9530',
    title: 'Repair and Maintenance (including Inspection) of Vehicles',
  },
  {
    ssic_code: '95301',
    title:
      'Repair and Maintenance of Motor Vehicles (including Installation of Parts & Accessories)',
  },
  {
    ssic_code: '95302',
    title: 'Car Washing and Related Services',
  },
  {
    ssic_code: '95303',
    title: 'Vehicle Inspection and Valuation Services',
  },
  {
    ssic_code: '960',
    title: 'Other Personal Service Activities',
  },
  {
    ssic_code: '9601',
    title: 'Washing and (dry-) Cleaning of Textile and Fur Products',
  },
  {
    ssic_code: '96011',
    title: 'Laundry and Dry Cleaning Services Except Self-Operated Laundries',
  },
  {
    ssic_code: '96012',
    title: 'Self-Operated Laundries',
  },
  {
    ssic_code: '9602',
    title: 'Hairdressing, Beauty and Other Personal Care Services',
  },
  {
    ssic_code: '96021',
    title: 'Hairdressing Salons/shops (including Barber Shops)',
  },
  {
    ssic_code: '96022',
    title:
      'Beauty Salons and Spas (including Slimming, Skin Care and Hair Care Centres)',
  },
  {
    ssic_code: '96023',
    title: 'Manicure and Pedicure Services',
  },
  {
    ssic_code: '96024',
    title: 'Massage Parlours and Foot Reflexology',
  },
  {
    ssic_code: '96029',
    title:
      'Beauty and Other Personal Care Services n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '9603',
    title: 'Funeral and Related Activities',
  },
  {
    ssic_code: '96030',
    title:
      'Funeral and Related Activities (including Embalming, Cremating and Cemetery Services, Upkeep of Cemeteries)',
  },
  {
    ssic_code: '9604',
    title: 'Wedding and Related Activities',
  },
  {
    ssic_code: '96040',
    title:
      'Wedding and Related Activities (including Bridal Studios and Wedding Planners)',
  },
  {
    ssic_code: '9609',
    title: 'Other Personal Service Activities n.e.c.',
  },
  {
    ssic_code: '96091',
    title: 'Friendship, Match-Making and Dating Services',
  },
  {
    ssic_code: '96092',
    title: 'Social Escort Services',
  },
  {
    ssic_code: '96093',
    title: 'Astrology, Palmistry and Other Fortune Telling Services',
  },
  {
    ssic_code: '96094',
    title: 'Training of Pets and Animals',
  },
  {
    ssic_code: '96095',
    title: 'Care Services for Pets and Animals',
  },
  {
    ssic_code: '96099',
    title:
      'Other Personal Service Activities n.e.c. (excluding Online Marketplaces)',
  },
  {
    ssic_code: '9700',
    title: 'Activities of Households As Employers of Domestic Personnel',
  },
  {
    ssic_code: '97001',
    title: 'Activities of Households As Employers of Domestic Workers',
  },
  {
    ssic_code: '97002',
    title:
      'Activities of Households As Employers of Other Domestic Personnel (e.g. Housekeepers)',
  },
  {
    ssic_code: '990',
    title: 'Activities of Extra-Territorial Organisations and Bodies',
  },
  {
    ssic_code: '99010',
    title: 'Foreign Embassies and Trade Representative Offices',
  },
  {
    ssic_code: '99020',
    title: 'Foreign Armed Forces',
  },
  {
    ssic_code: '99090',
    title: 'Other Extra-Territorial Organisations and Bodies',
  },
  {
    ssic_code: 'A',
    title: 'Agriculture and Fishing',
  },
  {
    ssic_code: 'C',
    title: 'Manufacturing',
  },
  {
    ssic_code: 'E',
    title:
      'Water Supply; Sewerage, Waste Management and Remediation Activities',
  },
  {
    ssic_code: 'F',
    title: 'Construction',
  },
  {
    ssic_code: 'G',
    title: 'Wholesale and Retail Trade',
  },
  {
    ssic_code: 'H',
    title: 'Transportation and Storage',
  },
  {
    ssic_code: 'I',
    title: 'Accommodation and Food Service Activities',
  },
  {
    ssic_code: 'J',
    title: 'Information and Communications',
  },
  {
    ssic_code: 'K',
    title: 'Financial and Insurance Activities',
  },
  {
    ssic_code: 'M',
    title: 'Professional, Scientific and Technical Activities',
  },
  {
    ssic_code: 'N',
    title: 'Administrative and Support Service Activities',
  },
  {
    ssic_code: 'Q',
    title: 'Health and Social Services',
  },
  {
    ssic_code: 'R',
    title: 'Arts, Entertainment and Recreation',
  },
  {
    ssic_code: 'S',
    title: 'Other Service Activities',
  },
];
